<template>
  <BaseTemplate app-name="Jurídico" page-title="">
    <template #content>
      <div class="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800 py-4 sm:py-8 px-4 md:px-8">
        <div class="w-full">
          <!-- Header -->
          <div class="mb-6 flex justify-between items-center">
            <h1 class="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">Módulo Jurídico</h1>
            <button
              @click="showGraficosRelatorios = !showGraficosRelatorios"
              class="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-all font-medium flex items-center gap-2"
            >
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
              </svg>
              {{ showGraficosRelatorios ? 'Ocultar' : 'Gráficos e Relatórios' }}
            </button>
          </div>

          <!-- Seção de Gráficos e Relatórios -->
          <Transition enter-active-class="transition-all duration-300 ease-out" leave-active-class="transition-all duration-300 ease-in" enter-from-class="translate-x-full opacity-0" leave-to-class="translate-x-full opacity-0">
            <div v-if="showGraficosRelatorios" class="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-4 sm:p-6 mb-6">
            <!-- Abas de Gráficos e Relatórios -->
            <div class="flex space-x-1 border-b border-gray-200 dark:border-gray-700 mb-6">
              <button
                @click="graficosRelatoriosTab = 'graficos'"
                :class="[
                  'px-4 py-2 text-sm font-medium transition-colors',
                  graficosRelatoriosTab === 'graficos'
                    ? 'border-b-2 border-blue-600 text-blue-600 dark:text-blue-400'
                    : 'text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200'
                ]"
              >
                Gráficos
              </button>
              <button
                @click="graficosRelatoriosTab = 'relatorios'"
                :class="[
                  'px-4 py-2 text-sm font-medium transition-colors',
                  graficosRelatoriosTab === 'relatorios'
                    ? 'border-b-2 border-blue-600 text-blue-600 dark:text-blue-400'
                    : 'text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200'
                ]"
              >
                Relatórios
              </button>
            </div>

            <!-- Conteúdo Gráficos -->
            <div v-if="graficosRelatoriosTab === 'graficos'" class="space-y-6">
              <!-- Filtros para Gráficos -->
              <div class="bg-gray-50 dark:bg-gray-700 rounded-lg p-4">
                <h3 class="text-lg font-semibold text-gray-800 dark:text-white mb-4">Filtros dos Gráficos</h3>
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Data Início</label>
                    <input v-model="filtrosGrafico.data_inicio" type="date" class="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white rounded-lg">
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Data Fim</label>
                    <input v-model="filtrosGrafico.data_fim" type="date" class="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white rounded-lg">
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Tipo de Processo</label>
                    <select v-model="filtrosGrafico.tipo_processo" class="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white rounded-lg">
                      <option value="">Todos</option>
                      <option value="civel">Cível</option>
                      <option value="criminal">Criminal</option>
                      <option value="trabalhista">Trabalhista</option>
                      <option value="administrativo">Administrativo</option>
                      <option value="outro">Outro</option>
                    </select>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Tipo de Demanda</label>
                    <select v-model="filtrosGrafico.tipo_demanda" class="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white rounded-lg">
                      <option value="">Todos</option>
                      <option value="vara">Vara</option>
                      <option value="oficial">Oficial</option>
                      <option value="email">E-mail</option>
                      <option value="pje">PJE</option>
                    </select>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Status</label>
                    <select v-model="filtrosGrafico.status" class="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white rounded-lg">
                      <option value="">Todos</option>
                      <option value="Pendente">Pendente</option>
                      <option value="Em Triagem">Em Triagem</option>
                      <option value="Aguardando Jurídico">Aguardando Jurídico</option>
                      <option value="Preparação do Ofício">Preparação do Ofício</option>
                      <option value="Cumprido">Cumprido</option>
                      <option value="Arquivado">Arquivado</option>
                    </select>
                  </div>
                  <div class="flex items-end">
                    <button
                      @click="carregarGraficos"
                      class="w-full px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all font-medium"
                    >
                      Aplicar Filtros
                    </button>
                  </div>
                </div>
              </div>

              <div v-if="carregandoGraficos" class="text-center py-8">
                <svg class="animate-spin h-8 w-8 text-blue-600 mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <p class="mt-4 text-gray-600 dark:text-gray-400">Carregando gráficos...</p>
              </div>

              <div v-else class="space-y-6">
                <!-- Métricas Resumidas -->
                <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div class="bg-blue-50 dark:bg-blue-900/30 rounded-lg p-4 border border-blue-200 dark:border-blue-800">
                    <p class="text-sm text-blue-600 dark:text-blue-400 font-medium">Total de Demandas</p>
                    <p class="text-2xl font-bold text-blue-800 dark:text-blue-200">{{ dadosGraficos.estatisticas?.total_demandas || 0 }}</p>
                  </div>
                  <div class="bg-green-50 dark:bg-green-900/30 rounded-lg p-4 border border-green-200 dark:border-green-800">
                    <p class="text-sm text-green-600 dark:text-green-400 font-medium">Demandas Pendentes</p>
                    <p class="text-2xl font-bold text-green-800 dark:text-green-200">{{ dadosGraficos.estatisticas?.demandas_pendentes || 0 }}</p>
                  </div>
                  <div class="bg-purple-50 dark:bg-purple-900/30 rounded-lg p-4 border border-purple-200 dark:border-purple-800">
                    <p class="text-sm text-purple-600 dark:text-purple-400 font-medium">Demandas Cumpridas</p>
                    <p class="text-2xl font-bold text-purple-800 dark:text-purple-200">{{ dadosGraficos.estatisticas?.demandas_cumpridas || 0 }}</p>
                  </div>
                </div>

                <!-- Gráficos -->
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
                  <!-- Gráfico por Tipo de Processo -->
                  <div class="bg-gray-50 dark:bg-gray-700 rounded-lg p-4">
                    <h3 class="text-lg font-semibold text-gray-800 dark:text-white mb-4">Demandas por Tipo de Processo</h3>
                    <div class="h-64">
                      <canvas ref="chartTipoProcesso"></canvas>
                    </div>
                  </div>

                  <!-- Gráfico por Tipo de Demanda -->
                  <div class="bg-gray-50 dark:bg-gray-700 rounded-lg p-4">
                    <h3 class="text-lg font-semibold text-gray-800 dark:text-white mb-4">Demandas por Tipo de Demanda</h3>
                    <div class="h-64">
                      <canvas ref="chartTipoDemanda"></canvas>
                    </div>
                  </div>

                  <!-- Gráfico por Prazo de Entrega -->
                  <div class="bg-gray-50 dark:bg-gray-700 rounded-lg p-4">
                    <h3 class="text-lg font-semibold text-gray-800 dark:text-white mb-4">Status do Prazo de Entrega</h3>
                    <div class="h-64">
                      <canvas ref="chartPrazoEntrega"></canvas>
                    </div>
                  </div>

                  <!-- Gráfico por Assunto -->
                  <div class="bg-gray-50 dark:bg-gray-700 rounded-lg p-4 lg:col-span-2">
                    <h3 class="text-lg font-semibold text-gray-800 dark:text-white mb-4">Demandas por Assunto</h3>
                    <div class="h-64">
                      <canvas ref="chartAssunto"></canvas>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Conteúdo Relatórios -->
            <div v-if="graficosRelatoriosTab === 'relatorios'" class="space-y-6">
              <!-- Filtros do Relatório -->
              <div class="bg-gray-50 dark:bg-gray-700 rounded-lg p-4">
                <h3 class="text-lg font-semibold text-gray-800 dark:text-white mb-4">Filtros do Relatório</h3>
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Status</label>
                    <select v-model="filtrosRelatorio.status" class="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white rounded-lg">
                      <option value="">Todos</option>
                      <option value="Pendente">Pendente</option>
                      <option value="Em Triagem">Em Triagem</option>
                      <option value="Aguardando Jurídico">Aguardando Jurídico</option>
                      <option value="Preparação do Ofício">Preparação do Ofício</option>
                      <option value="Cumprido">Cumprido</option>
                      <option value="Arquivado">Arquivado</option>
                    </select>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Data Início</label>
                    <input v-model="filtrosRelatorio.data_inicio" type="date" class="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white rounded-lg">
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Data Fim</label>
                    <input v-model="filtrosRelatorio.data_fim" type="date" class="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white rounded-lg">
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Tipo de Processo</label>
                    <select v-model="filtrosRelatorio.tipo_processo" class="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white rounded-lg">
                      <option value="">Todos</option>
                      <option value="civel">Cível</option>
                      <option value="criminal">Criminal</option>
                      <option value="trabalhista">Trabalhista</option>
                      <option value="administrativo">Administrativo</option>
                      <option value="outro">Outro</option>
                    </select>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Tipo de Demanda</label>
                    <select v-model="filtrosRelatorio.tipo_demanda" class="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white rounded-lg">
                      <option value="">Todos</option>
                      <option value="vara">Vara</option>
                      <option value="oficial">Oficial</option>
                      <option value="email">E-mail</option>
                      <option value="pje">PJE</option>
                    </select>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Prazo Vencido</label>
                    <select v-model="filtrosRelatorio.prazo_vencido" class="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white rounded-lg">
                      <option :value="null">Todos</option>
                      <option :value="true">Sim</option>
                      <option :value="false">Não</option>
                    </select>
                  </div>
                </div>

                <div class="mt-4 flex gap-3">
                  <button
                    @click="carregarRelatorio"
                    class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all font-medium"
                  >
                    Gerar Relatório
                  </button>
                  <button
                    v-if="dadosRelatorio.demandas && dadosRelatorio.demandas.length > 0"
                    @click="gerarPDF"
                    class="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-all font-medium flex items-center gap-2"
                  >
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                    </svg>
                    Exportar PDF
                  </button>
                </div>
              </div>

              <!-- Resultados do Relatório -->
              <div v-if="dadosRelatorio.demandas && dadosRelatorio.demandas.length > 0" class="bg-gray-50 dark:bg-gray-700 rounded-lg p-4">
                <h3 class="text-lg font-semibold text-gray-800 dark:text-white mb-4">
                  Resultados: {{ dadosRelatorio.total }} demanda(s) encontrada(s)
                </h3>
                <div class="overflow-x-auto">
                  <table class="w-full text-sm">
                    <thead class="bg-gray-200 dark:bg-gray-600">
                      <tr>
                        <th class="px-4 py-2 text-left">Protocolo</th>
                        <th class="px-4 py-2 text-left">Nome da Demanda</th>
                        <th class="px-4 py-2 text-left">Tipo Processo</th>
                        <th class="px-4 py-2 text-left">Tipo Demanda</th>
                        <th class="px-4 py-2 text-left">Prazo Entrega</th>
                        <th class="px-4 py-2 text-left">Status</th>
                        <th class="px-4 py-2 text-left">Prazo Vencido</th>
                        <th class="px-4 py-2 text-left">Assunto</th>
                      </tr>
                    </thead>
                    <tbody class="divide-y divide-gray-200 dark:divide-gray-600">
                      <tr v-for="demanda in dadosRelatorio.demandas" :key="demanda.protocolo" class="hover:bg-gray-100 dark:hover:bg-gray-600">
                        <td class="px-4 py-2">{{ demanda.protocolo }}</td>
                        <td class="px-4 py-2">{{ demanda.nome_demanda }}</td>
                        <td class="px-4 py-2">{{ demanda.tipo_processo }}</td>
                        <td class="px-4 py-2">{{ demanda.tipo_demanda }}</td>
                        <td class="px-4 py-2">{{ formatDate(demanda.prazo_entrega) }}</td>
                        <td class="px-4 py-2">
                          <span :class="getStatusClass(demanda.status)" class="px-2 py-1 text-xs font-medium rounded-full">
                            {{ demanda.status }}
                          </span>
                        </td>
                        <td class="px-4 py-2">
                          <span v-if="demanda.prazo_vencido !== null" :class="demanda.prazo_vencido ? 'text-red-600' : 'text-green-600'">
                            {{ demanda.prazo_vencido ? 'Sim' : 'Não' }}
                          </span>
                          <span v-else>-</span>
                        </td>
                        <td class="px-4 py-2">{{ demanda.assunto }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div v-else-if="!carregandoRelatorio && dadosRelatorio.demandas && dadosRelatorio.demandas.length === 0" class="text-center py-8 text-gray-500 dark:text-gray-400">
                Nenhuma demanda encontrada com os filtros aplicados.
              </div>
            </div>
          </div>
          </Transition>

          <!-- Filtros e Busca -->
          <div v-if="!showGraficosRelatorios" class="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-4 sm:p-6 mb-6">
            <div class="grid grid-cols-1 md:grid-cols-5 gap-4">
              <div class="md:col-span-2">
                <input 
                  v-model="searchTerm"
                  type="text" 
                  placeholder="Buscar por protocolo, nome da demanda ou número do processo..."
                  class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                >
              </div>
              <div>
                <select 
                  v-model="selectedStatus"
                  class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                >
                  <option value="todos">Todos os Status</option>
                  <option value="Pendente">Pendente</option>
                  <option value="Em Triagem">Em Triagem</option>
                  <option value="Aguardando Jurídico">Aguardando Jurídico</option>
                  <option value="Cumprido">Cumprido</option>
                  <option value="Arquivado">Arquivado</option>
                </select>
              </div>
              <button 
                @click="openCreateModal"
                class="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-all font-medium flex items-center justify-center text-sm md:text-base"
              >
                <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
                </svg>
                Nova Demanda
              </button>
              <button 
                @click="loadDemandas"
                class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all font-medium flex items-center justify-center text-sm md:text-base"
              >
                <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                </svg>
                Atualizar
              </button>
            </div>
            <div class="mt-4 flex flex-col sm:flex-row items-center justify-between">
              <div class="flex items-center space-x-2">
                <label class="text-sm font-medium text-gray-700 dark:text-gray-300">Itens por página:</label>
                <select 
                  v-model="itemsPerPage"
                  @change="loadDemandas"
                  class="px-3 py-1 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                >
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                </select>
              </div>
            </div>
          </div>

          <!-- Lista de Eventos -->
          <div v-if="!showGraficosRelatorios" class="hidden md:block bg-white dark:bg-gray-800 rounded-2xl shadow-lg overflow-hidden">
            <div class="overflow-x-auto">
              <table class="w-full">
                <thead class="bg-gray-50 dark:bg-gray-700">
                  <tr>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Protocolo</th>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Nome da Demanda</th>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Número do Processo</th>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Prazo de Entrega</th>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Data de Criação</th>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Status</th>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Ações</th>
                </tr>
                </thead>
                <tbody class="divide-y divide-gray-200 dark:divide-gray-600">
                  <tr v-for="demanda in filteredDemandas" :key="demanda.id" class="hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
                    <td class="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white">
                      {{ demanda.protocolo }}
                    </td>
                    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-600 dark:text-gray-300">
                      {{ demanda.nome_demanda }}
                    </td>
                    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-600 dark:text-gray-300">
                      {{ demanda.numero_processo }}
                    </td>
                    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-600 dark:text-gray-300">
                      {{ formatDate(demanda.prazo_entrega) }}
                    </td>
                    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-600 dark:text-gray-300">
                      {{ formatDate(demanda.data_registro) }}
                    </td>
                    <td class="px-4 py-4 whitespace-nowrap">
                      <span :class="getStatusClass(demanda.status)" class="px-2 py-1 text-xs font-medium rounded-full">
                        {{ demanda.status || 'Pendente' }}
                      </span>
                    </td>
                    <td class="px-4 py-4 whitespace-nowrap text-sm">
                      <div class="flex items-center space-x-2">
                        <button
                          @click="handleEditClick(demanda)"
                          class="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded-lg transition-all text-xs font-medium flex items-center gap-1.5"
                        >
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                          </svg>
                        </button>
                        <button
                          @click="openDetailsModal(demanda)"
                          class="bg-gray-600 hover:bg-gray-700 text-white px-2 py-1.5 rounded-lg transition-all"
                          title="Ver detalhes"
                        >
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                          </svg>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
          </table>
        </div>
        </div>

        <!-- Lista de Demandas (Mobile) -->
        <div v-if="!showGraficosRelatorios" class="block md:hidden space-y-4 -mx-3">
          <div
            v-for="demanda in filteredDemandas"
            :key="demanda.id"
            class="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-2xl shadow-md p-4 sm:p-6 mx-3 hover:shadow-lg transition-all"
          >
            <!-- Protocolo - Highlighted -->
            <div class="mb-3 pb-3 border-b border-gray-200 dark:border-gray-700">
              <div class="text-xs text-gray-500 dark:text-gray-400 mb-1">Protocolo</div>
              <div class="text-base font-bold text-gray-900 dark:text-white">
                {{ demanda.protocolo }}
              </div>
            </div>

            <!-- Nome da Demanda -->
            <div class="mb-3">
              <div class="text-xs text-gray-500 dark:text-gray-400 mb-1">Nome da Demanda</div>
              <div class="text-sm text-gray-900 dark:text-white">
                {{ demanda.nome_demanda }}
              </div>
            </div>

            <!-- Número do Processo -->
            <div class="mb-3">
              <div class="text-xs text-gray-500 dark:text-gray-400 mb-1">Número do Processo</div>
              <div class="text-sm text-gray-900 dark:text-white">
                {{ demanda.numero_processo }}
              </div>
            </div>

            <!-- Prazo de Entrega -->
            <div class="mb-3">
              <div class="text-xs text-gray-500 dark:text-gray-400 mb-1">Prazo de Entrega</div>
              <div class="text-sm text-gray-900 dark:text-white">
                {{ formatDate(demanda.prazo_entrega) }}
              </div>
            </div>

            <!-- Data de Criação -->
            <div class="mb-4">
              <div class="text-xs text-gray-500 dark:text-gray-400 mb-1">Data de Criação</div>
              <div class="text-sm text-gray-900 dark:text-white">
                {{ formatDate(demanda.data_registro) }}
              </div>
            </div>

            <!-- Status and Actions Row -->
            <div class="flex items-center justify-between pt-3 border-t border-gray-200 dark:border-gray-700">
              <!-- Status Badge -->
              <div>
                <span :class="getStatusClass(demanda.status)" class="px-2.5 py-1 text-xs font-medium rounded-full">
                  {{ demanda.status || 'Pendente' }}
                </span>
              </div>

              <!-- Action Buttons -->
              <div class="flex items-center gap-2">
                <button
                  @click="handleEditClick(demanda)"
                  class="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded-lg transition-all text-xs font-medium flex items-center gap-1.5"
                >
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                  </svg>
                </button>
                <button
                  @click="openDetailsModal(demanda)"
                  class="bg-gray-600 hover:bg-gray-700 text-white px-2 py-1.5 rounded-lg transition-all"
                  title="Ver detalhes"
                >
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <!-- Empty State for Mobile -->
          <div v-if="!showGraficosRelatorios && filteredDemandas.length === 0" class="text-center py-8 text-gray-500 dark:text-gray-400">
            Nenhuma demanda encontrada
          </div>
        </div>
        
        <!-- Paginação -->
        <div v-if="!showGraficosRelatorios" class="mt-6 flex flex-col sm:flex-row items-center justify-between bg-white dark:bg-gray-800 rounded-2xl p-4 sm:p-6 mb-4 sm:mb-0">
          <div class="text-sm text-gray-700 dark:text-gray-300 mb-2 sm:mb-0">
            Mostrando {{ ((currentPage - 1) * itemsPerPage) + 1 }} - {{ Math.min(currentPage * itemsPerPage, totalItems) }} de {{ totalItems }} itens
          </div>
          <div class="flex space-x-2">
            <button 
              @click="previousPage" 
              :disabled="currentPage === 1"
              class="px-3 py-1 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
            >
              Anterior
            </button>
            <span class="flex items-center px-3 py-1">
              Página {{ currentPage }} de {{ totalPages }}
            </span>
            <button 
              @click="nextPage" 
              :disabled="currentPage === totalPages"
              class="px-3 py-1 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
            >
              Próxima
            </button>
          </div>
        </div>
      </div>
        
        <!-- Modal de Criação -->
        <div v-if="showCreateModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4 sm:p-6 md:mt-14">
          <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-4xl w-full max-h-[80vh] overflow-y-auto">
            <!-- Header do Modal -->
            <div class="sticky top-0 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 p-4 sm:p-6 rounded-t-2xl">
              <div class="flex justify-between items-center">
                <div>
                  <h2 class="text-xl font-bold text-gray-800 dark:text-white">Nova Demanda Judicial</h2>
                  <p class="text-sm text-gray-600 dark:text-gray-300">Preencha os dados da demanda</p>
                </div>
                <button 
                  @click="closeCreateModal"
                  class="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
                >
                  <svg class="w-6 h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                  </svg>
                </button>
              </div>
            </div>

            <!-- Conteúdo do Modal -->
            <div class="p-4 sm:p-6">
              <form @submit.prevent="createDemanda" class="space-y-6">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Nome da Demanda <span class="text-red-500">*</span>
                    </label>
                    <input 
                      v-model="createForm.nome_demanda" 
                      type="text" 
                      required
                      class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                      placeholder="Nome da demanda judicial"
                    >
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Tipo de Demanda <span class="text-red-500">*</span>
                    </label>
                    <select 
                      v-model="createForm.tipo_demanda" 
                      required
                      class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    >
                      <option value="">Selecione...</option>
                      <option value="vara">Vara</option>
                      <option value="oficial">Oficial</option>
                      <option value="email">E-mail</option>
                      <option value="pje">PJE</option>
                    </select>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Número do Processo <span class="text-red-500">*</span>
                    </label>
                    <input 
                      v-model="createForm.numero_processo" 
                      type="text" 
                      required
                      class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                      placeholder="Número do processo"
                    >
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Tipo de Processo <span class="text-red-500">*</span>
                    </label>
                    <select 
                      v-model="createForm.tipo_processo" 
                      required
                      class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    >
                      <option value="">Selecione...</option>
                      <option value="civel">Cível</option>
                      <option value="criminal">Criminal</option>
                      <option value="trabalhista">Trabalhista</option>
                      <option value="administrativo">Administrativo</option>
                      <option value="outro">Outro</option>
                    </select>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Prazo de Entrega <span class="text-red-500">*</span>
                    </label>
                    <input 
                      v-model="createForm.prazo_entrega" 
                      type="date" 
                      required
                      class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    >
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Responsável pelo Registro
                    </label>
                    <input 
                      :value="getCurrentUserName()" 
                      type="text" 
                      disabled
                      class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg cursor-not-allowed"
                    >
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Responsável pela Triagem/Análise da Demanda
                    </label>
                    <select 
                      v-model="createForm.responsavel_triagem" 
                      class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    >
                      <option value="">Selecione o responsável...</option>
                      <option v-for="user in juridicoUsers" :key="user.id" :value="user.name">
                        {{ user.name }}
                      </option>
                    </select>
                  </div>

                </div>

                <!-- Envio de Email para Responsável da Triagem -->
                <div v-if="createForm.responsavel_triagem" class="border-t border-gray-200 dark:border-gray-700 pt-6 mt-6">
                  <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                    Notificação do Responsável pela Triagem
                  </h3>
                  
                  <div class="space-y-4">
                    <div>
                      <label class="flex items-center space-x-2">
                        <input 
                          type="checkbox" 
                          v-model="createForm.enviar_email_triagem"
                          @change="handleEmailTriagemChange"
                          class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                        >
                        <span class="text-sm font-medium text-gray-700 dark:text-gray-300">Enviar E-mail para Responsável pela Triagem</span>
                      </label>
                    </div>

                    <div v-if="createForm.enviar_email_triagem">
                      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                        Mensagem do E-mail (pode editar)
                      </label>
                      <textarea 
                        v-model="createForm.mensagem_email_triagem" 
                        rows="3"
                        class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all resize-none"
                        placeholder="Digite a mensagem do e-mail..."
                      ></textarea>
                    </div>
                  </div>
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Assunto
                  </label>
                  <select 
                    v-model="createForm.assunto_id" 
                    class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  >
                    <option :value="null">Selecione o assunto...</option>
                    <option v-for="assunto in assuntos" :key="assunto.id" :value="assunto.id">
                      {{ assunto.nome }}
                    </option>
                    <option value="outro">Outro</option>
                  </select>
                </div>

                <div v-if="createForm.assunto_id === 'outro'">
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Especifique o Assunto
                  </label>
                  <input 
                    v-model="createForm.assunto_outro" 
                    @input="createForm.assunto_outro = $event.target.value.toUpperCase()"
                    type="text" 
                    class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all uppercase"
                    placeholder="Digite o assunto"
                  >
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Observações
                  </label>
                  <textarea 
                    v-model="createForm.observacoes" 
                    rows="4"
                    class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all resize-none"
                    placeholder="Observações sobre a demanda..."
                  ></textarea>
                </div>

                <!-- Informações do Paciente -->
                <div class="border-t border-gray-200 dark:border-gray-700 pt-6 mt-6">
                  <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                    Informações do Paciente
                  </h3>
                  
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                        Nome do Paciente
                      </label>
                      <input 
                        v-model="createForm.nome_paciente" 
                        type="text" 
                        class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                        placeholder="Nome completo do paciente"
                      >
                    </div>

                    <div>
                      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                        CPF do Paciente
                      </label>
                      <input 
                        v-model="createForm.cpf_paciente" 
                        type="text" 
                        @input="formatarCPF"
                        maxlength="14"
                        class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                        placeholder="000.000.000-00"
                      >
                    </div>

                    <div>
                      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                        Data de Nascimento
                      </label>
                      <input 
                        v-model="createForm.data_nascimento_paciente" 
                        type="date" 
                        class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                      >
                    </div>

                    <div>
                      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                        Sexo
                      </label>
                      <select 
                        v-model="createForm.sexo_paciente" 
                        class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                      >
                        <option value="">Selecione...</option>
                        <option value="masculino">Masculino</option>
                        <option value="feminino">Feminino</option>
                        <option value="outro">Outro</option>
                      </select>
                    </div>
                  </div>

                  <div class="mt-4">
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Outras Informações do Paciente
                    </label>
                    <textarea 
                      v-model="createForm.outras_informacoes_paciente" 
                      rows="3"
                      class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all resize-none"
                      placeholder="Informações adicionais sobre o paciente"
                    ></textarea>
                  </div>
                </div>

                <!-- Seção de Anexos -->
                <div class="border-t border-gray-200 dark:border-gray-700 pt-6 mt-6">
                  <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                    Anexar Documentos (opcional)
                  </h3>
                  <div class="space-y-3">
                    <div class="flex items-center gap-2">
                      <input 
                        type="file" 
                        @change="adicionarAnexoCriacao"
                        accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                        multiple
                        class="hidden"
                        id="anexo-criacao-upload"
                      >
                      <label 
                        for="anexo-criacao-upload"
                        class="flex-1 px-4 py-2 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-lg hover:border-blue-500 dark:hover:border-blue-400 cursor-pointer transition-colors text-center text-sm text-gray-600 dark:text-gray-400"
                      >
                        <svg class="w-5 h-5 inline-block mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
                        </svg>
                        Selecionar Arquivos
                      </label>
                    </div>
                    
                    <!-- Lista de anexos selecionados -->
                    <div v-if="anexosParaCriacao.length > 0" class="space-y-2">
                      <div 
                        v-for="(anexo, index) in anexosParaCriacao" 
                        :key="anexo.id"
                        class="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700 rounded-lg"
                      >
                        <div class="flex items-center gap-3 flex-1">
                          <svg class="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                          </svg>
                          <div class="flex-1 min-w-0">
                            <p class="text-sm font-medium text-gray-900 dark:text-white truncate">{{ anexo.nome }}</p>
                            <p class="text-xs text-gray-500 dark:text-gray-400">{{ (anexo.file.size / 1024).toFixed(2) }} KB</p>
                          </div>
                        </div>
                        <button
                          type="button"
                          @click="removerAnexoCriacao(index)"
                          class="px-3 py-1 bg-red-600 text-white rounded hover:bg-red-700 transition-colors text-xs flex items-center justify-center"
                          title="Remover"
                        >
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Footer do Modal -->
                <div class="sticky bottom-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 p-4 sm:p-6 rounded-b-2xl -mx-4 -mb-4">
                  <div class="flex gap-3">
                    <button 
                      type="button"
                      @click="closeCreateModal"
                      class="flex-1 px-4 py-2.5 sm:px-6 sm:py-3 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-all font-medium text-xs sm:text-base md:text-lg"
                    >
                      Cancelar
                    </button>
                    <button 
                      type="submit"
                      :disabled="isCreating || uploadingAnexoCriacao"
                      class="flex-1 px-4 py-2.5 sm:px-6 sm:py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-all font-medium text-xs sm:text-base md:text-lg"
                    >
                      <span v-if="!isCreating && !uploadingAnexoCriacao">Criar Demanda</span>
                      <span v-else-if="uploadingAnexoCriacao" class="flex items-center justify-center">
                        <svg class="animate-spin -ml-1 mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Enviando anexos...
                      </span>
                      <span v-else class="flex items-center justify-center">
                        <svg class="animate-spin -ml-1 mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Criando...
                      </span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <!-- Modal de Edição -->
        <div v-if="showModal && podeEditar" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4 sm:p-6 md:mt-14">
          <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-4xl w-full max-h-[80vh] overflow-y-auto">
            <!-- Header do Modal -->
            <div class="sticky top-0 z-20 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 p-4 sm:p-6 rounded-t-2xl shadow-sm">
              <div class="flex justify-between items-center">
                <div>
                  <h2 class="text-xl font-bold text-gray-800 dark:text-white">Gerenciar Demanda Judicial</h2>
                  <p class="text-sm text-gray-600 dark:text-gray-300">Protocolo: {{ selectedDemanda?.protocolo }}</p>
                </div>
                <button 
                  @click="closeModal"
                  class="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
                >
                  <svg class="w-6 h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                  </svg>
                </button>
              </div>

              <!-- Navegação das Fases -->
              <div class="mt-4 bg-gray-100 dark:bg-gray-700 rounded-lg p-1">
                <div class="flex overflow-x-auto space-x-1">
                  <button 
                    v-for="fase in fases" 
                    :key="fase.id"
                    @click="currentPhase = fase.id"
                    :disabled="!isFaseDisponivel(fase.id)"
                    :class="[
                      'flex-shrink-0 sm:flex-1 py-2 px-4 rounded-md text-sm font-medium transition-all whitespace-nowrap',
                      currentPhase === fase.id 
                        ? 'bg-white dark:bg-gray-600 text-blue-600 dark:text-blue-400 shadow-sm' 
                        : 'text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-800 dark:hover:text-white',
                      !isFaseDisponivel(fase.id) 
                        ? 'opacity-50 cursor-not-allowed' 
                        : ''
                    ]"
                  >
                    {{ fase.name }}
                  </button>
                </div>
              </div>
            </div>

            <!-- Conteúdo do Modal -->
            <div class="p-4 sm:p-6">
              <!-- Etapa 1: Registro da Demanda Judicial -->
              <div v-if="currentPhase === 1" class="space-y-6">
                <h3 class="text-lg font-semibold text-gray-800 dark:text-white mb-4 flex items-center">
                  <span class="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">1</span>
                  Registro da Demanda Judicial
                </h3>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Protocolo
                    </label>
                    <input 
                     :value="selectedDemanda?.protocolo" 
                     type="text" 
                     disabled
                     class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg"
                   >
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Nome da Demanda
                    </label>
                    <input 
                     :value="selectedDemanda?.nome_demanda" 
                     type="text" 
                     disabled
                     class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg"
                   >
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Tipo de Demanda
                    </label>
                    <input 
                     :value="selectedDemanda?.tipo_demanda" 
                     type="text" 
                     disabled
                     class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg"
                   >
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Número do Processo
                    </label>
                    <input 
                     :value="selectedDemanda?.numero_processo" 
                     type="text" 
                     disabled
                     class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg"
                   >
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Tipo de Processo
                    </label>
                    <input 
                     :value="selectedDemanda?.tipo_processo" 
                     type="text" 
                     disabled
                     class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg"
                   >
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Prazo de Entrega
                    </label>
                    <input 
                     :value="formatDate(selectedDemanda?.prazo_entrega)" 
                     type="text" 
                     disabled
                     class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg"
                   >
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Responsável pelo Registro
                    </label>
                    <input 
                     :value="selectedDemanda?.responsavel_registro || getCurrentUserName()" 
                     type="text" 
                     disabled
                     class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg"
                   >
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Data de Criação
                    </label>
                    <input 
                     :value="formatDate(selectedDemanda?.data_registro)" 
                     type="text" 
                     disabled
                     class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg"
                   >
                  </div>

                  <div class="md:col-span-2">
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Responsável pela Etapa 2 - Triagem
                    </label>
                    <input 
                     :value="selectedDemanda?.responsavel_triagem || '-'" 
                     type="text" 
                     disabled
                     class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg"
                   >
                  </div>
                </div>

                <div class="space-y-6">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Assunto
                    </label>
                    <select 
                      v-model="createForm.assunto_id" 
                      class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    >
                      <option :value="null">Selecione o assunto...</option>
                      <option v-for="assunto in assuntos" :key="assunto.id" :value="assunto.id">
                        {{ assunto.nome }}
                      </option>
                      <option value="outro">Outro</option>
                    </select>
                  </div>

                  <div v-if="createForm.assunto_id === 'outro'">
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Especifique o Assunto
                    </label>
                    <input 
                      v-model="createForm.assunto_outro" 
                      @input="createForm.assunto_outro = $event.target.value.toUpperCase()"
                      type="text" 
                      class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all uppercase"
                      placeholder="Digite o assunto"
                    >
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Assunto
                    </label>
                    <input 
                      :value="selectedDemanda?.assunto ? selectedDemanda.assunto.nome : (selectedDemanda?.assunto_outro || '-')" 
                      type="text" 
                      disabled
                      class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg"
                    >
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Observações
                    </label>
                    <textarea 
                     :value="selectedDemanda?.observacoes" 
                     disabled
                     class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg resize-none"
                     rows="4"
                   ></textarea>
                  </div>

                  <!-- Informações do Paciente - Etapa 1 -->
                  <div class="border-t border-gray-200 dark:border-gray-700 pt-6">
                    <h4 class="text-md font-semibold text-gray-800 dark:text-white mb-4">
                      Informações do Paciente
                    </h4>
                    
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                          Nome do Paciente
                  </label>
                  <input 
                          :value="selectedDemanda?.nome_paciente || '-'" 
                   type="text" 
                   disabled
                   class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg"
                 >
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                          CPF do Paciente
                    </label>
                        <input 
                          :value="selectedDemanda?.cpf_paciente || '-'" 
                          type="text" 
                     disabled
                          class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg"
                        >
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                          Data de Nascimento
                  </label>
                        <input 
                          :value="selectedDemanda?.data_nascimento_paciente ? new Date(selectedDemanda.data_nascimento_paciente).toLocaleDateString('pt-BR') : '-'" 
                          type="text" 
                   disabled
                          class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg"
                        >
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                          Sexo
                        </label>
                        <input 
                          :value="selectedDemanda?.sexo_paciente === 'masculino' ? 'Masculino' : selectedDemanda?.sexo_paciente === 'feminino' ? 'Feminino' : selectedDemanda?.sexo_paciente === 'outro' ? 'Outro' : '-'" 
                          type="text" 
                          disabled
                          class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg"
                        >
                      </div>
                    </div>

                    <div class="mt-4">
                      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                        Outras Informações do Paciente
                    </label>
                    <textarea 
                        :value="selectedDemanda?.outras_informacoes_paciente || '-'" 
                     disabled
                     class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg resize-none"
                     rows="3"
                   ></textarea>
                  </div>
                </div>

                  <!-- Seção de Anexos - Etapa 1 -->
                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Anexos
                  </label>
                    <div class="space-y-3">
                      <!-- Upload de novo anexo -->
                      <div class="flex items-center gap-2">
                  <input 
                          type="file" 
                          @change="handleFileSelect"
                          accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.txt"
                          class="hidden"
                          id="anexo-upload-etapa1"
                        >
                        <label 
                          for="anexo-upload-etapa1"
                          class="flex-1 px-4 py-2 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-lg hover:border-blue-500 dark:hover:border-blue-400 cursor-pointer transition-colors text-center text-sm text-gray-600 dark:text-gray-400"
                        >
                          <svg class="w-5 h-5 inline-block mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
                          </svg>
                          Adicionar Anexo (PDF, Imagem, Documento)
                    </label>
                        <button
                          v-if="selectedFile"
                          @click="uploadAnexo(1)"
                          :disabled="uploadingAnexo"
                          class="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-400 transition-colors text-sm"
                        >
                          <span v-if="!uploadingAnexo">Enviar</span>
                          <span v-else>Enviando...</span>
                        </button>
              </div>

                      <!-- Lista de anexos -->
                      <div v-if="anexos.length > 0" class="space-y-2">
                        <div 
                          v-for="anexo in anexos" 
                          :key="anexo.id"
                          class="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700 rounded-lg"
                        >
                          <div class="flex items-center gap-3 flex-1">
                            <svg class="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                            </svg>
                            <div class="flex-1 min-w-0">
                              <p class="text-sm font-medium text-gray-900 dark:text-white truncate">{{ anexo.nome }}</p>
                              <p v-if="anexo.usuario" class="text-xs text-gray-600 dark:text-gray-300 font-medium">Enviado por: {{ anexo.usuario }}</p>
                              <p v-if="anexo.descricao" class="text-xs text-gray-500 dark:text-gray-400">{{ anexo.descricao }}</p>
                              <p class="text-xs text-gray-500 dark:text-gray-400">{{ formatDate(anexo.data_upload) }}</p>
                  </div>
                          </div>
                          <div class="flex items-center gap-2">
                            <button
                              @click="openAnexoModal(anexo)"
                              class="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors text-xs flex items-center justify-center"
                              title="Ver"
                            >
                              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                              </svg>
                            </button>
                            <button
                              v-if="podeDeletarAnexo(anexo)"
                              @click="deletarAnexo(anexo.id)"
                              class="px-3 py-1 bg-red-600 text-white rounded hover:bg-red-700 transition-colors text-xs flex items-center justify-center"
                              title="Excluir"
                            >
                              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Etapa 2: Triagem/Análise -->
              <div v-if="currentPhase === 2" class="space-y-6">
                <h3 class="text-lg font-semibold text-gray-800 dark:text-white mb-4 flex items-center">
                  <span class="w-8 h-8 bg-orange-500 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">2</span>
                  Triagem / Análise
                </h3>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Data do Início da Triagem
                    </label>
                    <input 
                     v-model="modalForm.dataInicioTriagem" 
                     type="date" 
                     :disabled="isFaseReadOnly(2)"
                     class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all disabled:bg-gray-100 disabled:cursor-not-allowed"
                   >
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Data da Devolução da Triagem
                    </label>
                    <input 
                     v-model="modalForm.dataDevolucaoTriagem" 
                     type="date" 
                     :disabled="isFaseReadOnly(2)"
                     class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all disabled:bg-gray-100 disabled:cursor-not-allowed"
                   >
                  </div>

                  <div class="md:col-span-2">
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Responsável pela Triagem
                    </label>
                    <select 
                     v-model="modalForm.responsavelTriagem" 
                     :disabled="isFaseReadOnly(2)"
                     class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all disabled:bg-gray-100 disabled:cursor-not-allowed"
                   >
                      <option value="">Selecione o responsável...</option>
                      <option v-for="user in juridicoUsers" :key="user.id" :value="user.name">
                        {{ user.name }}
                      </option>
                    </select>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Prioridade
                    </label>
                    <select 
                     v-model="modalForm.prioridade" 
                     :disabled="isFaseReadOnly(2)"
                     class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all disabled:bg-gray-100 disabled:cursor-not-allowed"
                   >
                      <option value="">Selecione...</option>
                      <option value="baixa">Baixa</option>
                      <option value="media">Média</option>
                      <option value="alta">Alta</option>
                      <option value="urgente">Urgente</option>
                    </select>
                  </div>

                  <div class="md:col-span-2">
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Análise da Triagem
                    </label>
                    <textarea 
                     v-model="modalForm.analiseTriagem" 
                     rows="4"
                     :disabled="isFaseReadOnly(2)"
                     class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all resize-none disabled:bg-gray-100 disabled:cursor-not-allowed"
                     placeholder="Descreva a análise da triagem..."
                   ></textarea>
                  </div>

                  <div class="md:col-span-2">
                    <label class="flex items-center space-x-2">
                      <input 
                        type="checkbox" 
                        v-model="modalForm.enviarEmailJuridicoEtapa2"
                        @change="handleEmailJuridicoEtapa2Change"
                        :disabled="isFaseReadOnly(2)"
                        class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                      >
                      <span class="text-sm font-medium text-gray-700 dark:text-gray-300">Enviar E-mail para Jurídico</span>
                    </label>
                  </div>

                  <div v-if="modalForm.enviarEmailJuridicoEtapa2" class="md:col-span-2 space-y-3">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                        Destinatários
                    </label>
                      <div class="flex gap-2">
                        <div class="flex-1 relative">
                    <select 
                            v-model="novoDestinatarioJuridicoEtapa2"
                            @change="adicionarDestinatarioJuridicoEtapa2"
                     :disabled="isFaseReadOnly(2)"
                     class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all disabled:bg-gray-100 disabled:cursor-not-allowed"
                   >
                            <option value="">Selecione um destinatário...</option>
                            <optgroup label="Usuários">
                              <option v-for="user in juridicoUsers" :key="user.id" :value="user.name">
                                {{ user.name }} {{ user.email ? `(${user.email})` : '' }}
                      </option>
                            </optgroup>
                            <optgroup label="E-mails Customizados">
                              <option v-for="email in emailsCustomizados" :key="email.id" :value="email.email">
                                {{ email.email }} {{ email.nome ? `- ${email.nome}` : '' }}
                              </option>
                            </optgroup>
                    </select>
                        </div>
                        <button
                          @click="showEmailCustomizadoModal = true"
                          :disabled="isFaseReadOnly(2)"
                          class="px-2 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-400 transition-colors flex items-center justify-center"
                          title="Adicionar novo e-mail"
                        >
                          <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
                          </svg>
                        </button>
                  </div>

                      <!-- Lista de destinatários selecionados -->
                      <div v-if="modalForm.destinatariosEmailJuridicoEtapa2.length > 0" class="mt-2 space-y-2">
                        <div
                          v-for="(dest, index) in modalForm.destinatariosEmailJuridicoEtapa2"
                          :key="index"
                          class="flex items-center justify-between bg-blue-50 dark:bg-blue-900/30 border border-blue-200 dark:border-blue-700 rounded-lg px-3 py-2"
                        >
                          <span class="text-sm font-medium text-blue-900 dark:text-blue-200 flex-1">{{ dest }}</span>
                          <button
                            @click="removerDestinatarioJuridicoEtapa2(index)"
                     :disabled="isFaseReadOnly(2)"
                            class="ml-2 text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-300 disabled:opacity-50 transition-colors"
                            title="Remover"
                          >
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                            </svg>
                          </button>
                        </div>
                      </div>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                        Mensagem do E-mail (pode editar)
                    </label>
                    <textarea 
                       v-model="modalForm.mensagemEmailJuridicoEtapa2" 
                     rows="3"
                     :disabled="isFaseReadOnly(2)"
                     class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all resize-none disabled:bg-gray-100 disabled:cursor-not-allowed"
                       placeholder="Ex: {usuario} enviou um email com as informações da demanda e o prazo para conclusão"
                   ></textarea>
                  </div>
                  
                  <!-- Botão de reenvio de email se houve erro -->
                  <div v-if="erroEmailFase === 2 && modalForm.enviarEmailJuridicoEtapa2" class="mt-3">
                    <div class="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-3 flex items-center justify-between">
                      <div class="flex items-center gap-2">
                        <svg class="w-5 h-5 text-red-600 dark:text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
                        </svg>
                        <span class="text-sm text-red-800 dark:text-red-300">Erro ao enviar e-mail. Clique para reenviar.</span>
                      </div>
                      <button
                        @click="reenviarEmail(2)"
                        :disabled="isReenviandoEmail"
                        class="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-all font-medium flex items-center gap-2 text-sm"
                      >
                        <svg v-if="!isReenviandoEmail" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                        </svg>
                        <svg v-else class="w-4 h-4 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                        </svg>
                        {{ isReenviandoEmail ? 'Reenviando...' : 'Reenviar' }}
                      </button>
                    </div>
                </div>
              </div>

                  <!-- Seção de Anexos - Etapa 2 -->
                  <div class="md:col-span-2">
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Anexos da Demanda
                    </label>
                    <div class="space-y-3">
                      <!-- Upload de novo anexo -->
                      <div class="flex items-center gap-2">
                        <input 
                          type="file" 
                          @change="handleFileSelect"
                          accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.txt"
                          class="hidden"
                          :id="`anexo-upload-etapa2`"
                        >
                        <label 
                          :for="`anexo-upload-etapa2`"
                          class="flex-1 px-4 py-2 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-lg hover:border-blue-500 dark:hover:border-blue-400 cursor-pointer transition-colors text-center text-sm text-gray-600 dark:text-gray-400"
                        >
                          <svg class="w-5 h-5 inline-block mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
                          </svg>
                          Adicionar Anexo
                        </label>
                        <button
                          v-if="selectedFile"
                          @click="uploadAnexo(2)"
                          :disabled="uploadingAnexo"
                          class="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-400 transition-colors text-sm"
                        >
                          <span v-if="!uploadingAnexo">Enviar</span>
                          <span v-else>Enviando...</span>
                        </button>
              </div>

                      <!-- Lista de anexos -->
                      <div v-if="anexos.length > 0" class="space-y-2">
                        <div 
                          v-for="anexo in anexos" 
                          :key="anexo.id"
                          class="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700 rounded-lg"
                        >
                          <div class="flex items-center gap-3 flex-1">
                            <svg class="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                            </svg>
                            <div class="flex-1 min-w-0">
                              <p class="text-sm font-medium text-gray-900 dark:text-white truncate">{{ anexo.nome }}</p>
                              <p v-if="anexo.usuario" class="text-xs text-gray-600 dark:text-gray-300 font-medium">Enviado por: {{ anexo.usuario }}</p>
                              <p v-if="anexo.descricao" class="text-xs text-gray-500 dark:text-gray-400">{{ anexo.descricao }}</p>
                              <p class="text-xs text-gray-500 dark:text-gray-400">{{ formatDate(anexo.data_upload) }}</p>
                            </div>
                          </div>
                          <div class="flex items-center gap-2">
                            <button
                              @click="openAnexoModal(anexo)"
                              class="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors text-xs flex items-center justify-center"
                              title="Ver"
                            >
                              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                              </svg>
                            </button>
                            <button
                              v-if="podeDeletarAnexo(anexo)"
                              @click="deletarAnexo(anexo.id)"
                              class="px-3 py-1 bg-red-600 text-white rounded hover:bg-red-700 transition-colors text-xs flex items-center justify-center"
                              title="Excluir"
                            >
                              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Etapa 3: Resposta do Jurídico -->
              <div v-if="currentPhase === 3" class="space-y-6">
                <h3 class="text-lg font-semibold text-gray-800 dark:text-white mb-4 flex items-center">
                  <span class="w-8 h-8 bg-purple-500 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">3</span>
                  Resposta do Jurídico
                </h3>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Data de Recebimento da Resposta do Jurídico
                    </label>
                    <input 
                     v-model="modalForm.dataRecebimentoRespostaJuridico" 
                     type="date" 
                     :disabled="isFaseReadOnly(3)"
                     class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all disabled:bg-gray-100 disabled:cursor-not-allowed"
                   >
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Responsável pelo Recebimento
                    </label>
                    <input 
                     v-model="modalForm.responsavelRecebimentoJuridico" 
                     type="text" 
                     :disabled="isFaseReadOnly(3)"
                     class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all disabled:bg-gray-100 disabled:cursor-not-allowed"
                     placeholder="Nome do responsável"
                   >
                  </div>

                  <div class="md:col-span-2">
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Resposta do Jurídico
                    </label>
                    <textarea 
                     v-model="modalForm.respostaJuridico" 
                     rows="4"
                     :disabled="isFaseReadOnly(3)"
                     class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all resize-none disabled:bg-gray-100 disabled:cursor-not-allowed"
                     placeholder="Digite a resposta do jurídico..."
                   ></textarea>
                  </div>

                  <!-- Upload de Respostas do Jurídico -->
                  <div class="md:col-span-2">
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Respostas do Jurídico (Anexos)
                    </label>
                    <div class="space-y-3">
                      <div class="flex items-center gap-2">
                        <input 
                          type="file" 
                          @change="handleRespostaJuridicoSelect"
                          accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                          class="hidden"
                          id="resposta-juridico-upload"
                        >
                        <label 
                          for="resposta-juridico-upload"
                          class="flex-1 px-4 py-2 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-lg hover:border-blue-500 dark:hover:border-blue-400 cursor-pointer transition-colors text-center text-sm text-gray-600 dark:text-gray-400"
                        >
                          <svg class="w-5 h-5 inline-block mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
                          </svg>
                          Adicionar Resposta do Jurídico
                        </label>
                        <button
                          v-if="selectedRespostaJuridicoFile"
                          @click="uploadRespostaJuridico"
                          :disabled="uploadingAnexo"
                          class="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-400 transition-colors text-sm"
                        >
                          <span v-if="!uploadingAnexo">Enviar</span>
                          <span v-else>Enviando...</span>
                        </button>
                      </div>
                      
                      <!-- Respostas do Jurídico existentes -->
                      <div v-if="respostasJuridico.length > 0" class="space-y-2">
                        <div 
                          v-for="resposta in respostasJuridico" 
                          :key="resposta.id"
                          class="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700 rounded-lg"
                        >
                          <div class="flex items-center gap-3 flex-1">
                            <svg class="w-5 h-5 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                            </svg>
                            <div class="flex-1 min-w-0">
                              <p class="text-sm font-medium text-gray-900 dark:text-white truncate">{{ resposta.nome }}</p>
                              <p v-if="resposta.usuario" class="text-xs text-gray-600 dark:text-gray-300 font-medium">Enviado por: {{ resposta.usuario }}</p>
                              <p v-if="resposta.descricao" class="text-xs text-gray-500 dark:text-gray-400">{{ resposta.descricao }}</p>
                              <p class="text-xs text-gray-500 dark:text-gray-400">{{ formatDate(resposta.data_upload) }}</p>
                            </div>
                          </div>
                          <button
                            @click="openAnexoModal(resposta)"
                            class="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors text-xs flex items-center justify-center"
                            title="Ver"
                          >
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                            </svg>
                          </button>
                        </div>
                  </div>
                </div>
              </div>

                  <!-- Anexos da Demanda (visualização) -->
                  <div v-if="anexos.length > 0" class="md:col-span-2">
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Anexos da Demanda
                    </label>
                    <div class="space-y-2">
                      <div 
                        v-for="anexo in anexos" 
                        :key="anexo.id"
                        class="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700 rounded-lg"
                      >
                        <div class="flex items-center gap-3 flex-1">
                          <svg class="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                          </svg>
                          <div class="flex-1 min-w-0">
                            <p class="text-sm font-medium text-gray-900 dark:text-white truncate">{{ anexo.nome }}</p>
                            <p v-if="anexo.usuario" class="text-xs text-gray-600 dark:text-gray-300 font-medium">Enviado por: {{ anexo.usuario }}</p>
                            <p v-if="anexo.descricao" class="text-xs text-gray-500 dark:text-gray-400">{{ anexo.descricao }}</p>
                            <p class="text-xs text-gray-500 dark:text-gray-400">{{ formatDate(anexo.data_upload) }}</p>
                          </div>
                        </div>
                        <button
                          @click="openAnexoModal(anexo)"
                          class="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors text-xs flex items-center justify-center"
                          title="Ver"
                        >
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Etapa 4: Envio para SMS -->
              <div v-if="currentPhase === 4" class="space-y-6">
                <h3 class="text-lg font-semibold text-gray-800 dark:text-white mb-4 flex items-center">
                  <span class="w-8 h-8 bg-indigo-500 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">4</span>
                  Envio para SMS
                </h3>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Data de Preparação do Ofício
                    </label>
                    <input 
                     v-model="modalForm.dataPreparacaoOficio" 
                     type="date" 
                     :disabled="isFaseReadOnly(4)"
                     class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all disabled:bg-gray-100 disabled:cursor-not-allowed"
                   >
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Responsável pelo Ofício
                    </label>
                    <input 
                     v-model="modalForm.responsavelOficio" 
                     type="text" 
                     :disabled="isFaseReadOnly(4)"
                     class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all disabled:bg-gray-100 disabled:cursor-not-allowed"
                     placeholder="Nome do responsável"
                   >
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Data de Envio ao Judiciário
                    </label>
                    <input 
                     v-model="modalForm.dataEnvioJudiciario" 
                     type="date" 
                     :disabled="isFaseReadOnly(4)"
                     class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all disabled:bg-gray-100 disabled:cursor-not-allowed"
                   >
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Responsável pelo Envio
                    </label>
                    <input 
                     v-model="modalForm.responsavelEnvio" 
                     type="text" 
                     :disabled="isFaseReadOnly(4)"
                     class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all disabled:bg-gray-100 disabled:cursor-not-allowed"
                     placeholder="Nome do responsável"
                   >
                  </div>

                  <div class="md:col-span-2">
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Método de Envio
                    </label>
                    <select 
                     v-model="modalForm.metodoEnvio" 
                     :disabled="isFaseReadOnly(4)"
                     class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all disabled:bg-gray-100 disabled:cursor-not-allowed"
                   >
                      <option value="">Selecione o método...</option>
                      <option value="E-mail">E-mail</option>
                      <option value="Sistema PJE">Sistema PJE</option>
                      <option value="Protocolo Físico">Protocolo Físico</option>
                      <option value="Outro">Outro</option>
                    </select>
                  </div>

                  <!-- Upload de Ofícios -->
                  <div class="md:col-span-2">
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Ofícios de Resposta
                    </label>
                    <div class="space-y-3">
                      <div class="flex items-center gap-2">
                        <input 
                          type="file" 
                          @change="handleOficioSelect"
                          accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                          class="hidden"
                          id="oficio-upload"
                        >
                        <label 
                          for="oficio-upload"
                          class="flex-1 px-4 py-2 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-lg hover:border-blue-500 dark:hover:border-blue-400 cursor-pointer transition-colors text-center text-sm text-gray-600 dark:text-gray-400"
                        >
                          <svg class="w-5 h-5 inline-block mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
                          </svg>
                          Adicionar Ofício
                        </label>
                        <button
                          v-if="selectedOficioFile"
                          @click="uploadOficio"
                          :disabled="uploadingAnexo"
                          class="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-400 transition-colors text-sm"
                        >
                          <span v-if="!uploadingAnexo">Enviar</span>
                          <span v-else>Enviando...</span>
                        </button>
                      </div>
                      
                      <!-- Ofícios existentes -->
                      <div v-if="oficios.length > 0" class="space-y-2">
                        <div 
                          v-for="oficio in oficios" 
                          :key="oficio.id"
                          class="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700 rounded-lg"
                        >
                          <div class="flex items-center gap-3 flex-1">
                            <svg class="w-5 h-5 text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                            </svg>
                            <div class="flex-1 min-w-0">
                              <p class="text-sm font-medium text-gray-900 dark:text-white truncate">{{ oficio.nome }}</p>
                              <p v-if="oficio.usuario" class="text-xs text-gray-600 dark:text-gray-300 font-medium">Enviado por: {{ oficio.usuario }}</p>
                              <p v-if="oficio.descricao" class="text-xs text-gray-500 dark:text-gray-400">{{ oficio.descricao }}</p>
                              <p class="text-xs text-gray-500 dark:text-gray-400">{{ formatDate(oficio.data_upload) }}</p>
                            </div>
                          </div>
                          <button
                            @click="openAnexoModal(oficio)"
                            class="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors text-xs flex items-center justify-center"
                            title="Ver"
                          >
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                            </svg>
                          </button>
                        </div>
                </div>
              </div>
                  </div>

                  <!-- Enviar E-mail para SMS -->
                  <div class="md:col-span-2">
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Enviar E-mail para SMS
                    </label>
                    <div class="flex gap-2">
                      <div class="flex-1 relative">
                        <select 
                          v-model="novoDestinatarioSms"
                          @change="adicionarDestinatarioSms"
                          :disabled="isFaseReadOnly(4)"
                          class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all disabled:bg-gray-100 disabled:cursor-not-allowed"
                        >
                          <option value="">Selecione um destinatário...</option>
                          <optgroup label="Usuários">
                            <option v-for="user in juridicoUsers" :key="user.id" :value="user.name">
                              {{ user.name }} {{ user.email ? `(${user.email})` : '' }}
                            </option>
                          </optgroup>
                          <optgroup label="E-mails Customizados">
                            <option v-for="email in emailsCustomizados" :key="email.id" :value="email.email">
                              {{ email.email }} {{ email.nome ? `- ${email.nome}` : '' }}
                            </option>
                          </optgroup>
                        </select>
                      </div>
                      <button
                        @click="showEmailCustomizadoModal = true"
                        :disabled="isFaseReadOnly(4)"
                        class="px-2 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-400 transition-colors flex items-center justify-center"
                        title="Adicionar novo e-mail"
                      >
                        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
                        </svg>
                      </button>
                    </div>

                    <!-- Lista dos destinatários selecionados -->
                    <div v-if="modalForm.destinatariosEmailSms.length > 0" class="mt-2 space-y-2">
                      <div
                        v-for="(dest, index) in modalForm.destinatariosEmailSms"
                        :key="index"
                        class="flex items-center justify-between bg-gray-50 dark:bg-gray-700/50 border border-gray-200 dark:border-gray-600 rounded-lg px-3 py-2"
                      >
                        <span class="text-sm font-medium text-gray-900 dark:text-gray-200 flex-1">{{ dest }}</span>
                        <button
                          @click="removerDestinatarioSms(index)"
                          :disabled="isFaseReadOnly(4)"
                          class="ml-2 text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-300 disabled:opacity-50 transition-colors"
                          title="Remover"
                        >
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="md:col-span-2">
                    <label class="flex items-center space-x-2">
                      <input 
                        type="checkbox" 
                        v-model="modalForm.enviarEmailSms"
                        @change="handleEmailSmsChange"
                        :disabled="isFaseReadOnly(4)"
                        class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                      >
                      <span class="text-sm font-medium text-gray-700 dark:text-gray-300">Enviar E-mail para SMS</span>
                    </label>
                  </div>

                  <div v-if="modalForm.enviarEmailSms" class="md:col-span-2">
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Mensagem do E-mail (pode editar)
                    </label>
                    <textarea 
                     v-model="modalForm.mensagemEmailSms" 
                     rows="3"
                     :disabled="isFaseReadOnly(4)"
                     class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all resize-none disabled:bg-gray-100 disabled:cursor-not-allowed"
                     placeholder="O email conterá todos os anexos, incluindo respostas do jurídico e ofícios."
                   ></textarea>
                   
                   <!-- Botão de reenvio de email se houve erro -->
                   <div v-if="erroEmailFase === 4 && modalForm.enviarEmailSms" class="mt-3">
                     <div class="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-3 flex items-center justify-between">
                       <div class="flex items-center gap-2">
                         <svg class="w-5 h-5 text-red-600 dark:text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                           <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
                         </svg>
                         <span class="text-sm text-red-800 dark:text-red-300">Erro ao enviar e-mail. Clique para reenviar.</span>
                       </div>
                       <button
                         @click="reenviarEmail(4)"
                         :disabled="isReenviandoEmail"
                         class="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-all font-medium flex items-center gap-2 text-sm"
                       >
                         <svg v-if="!isReenviandoEmail" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                           <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                         </svg>
                         <svg v-else class="w-4 h-4 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                           <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                         </svg>
                         {{ isReenviandoEmail ? 'Reenviando...' : 'Reenviar' }}
                       </button>
                     </div>
                  </div>
                </div>

                  <!-- Anexos da Demanda (visualização) -->
                  <div v-if="anexos.length > 0" class="md:col-span-2">
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Anexos da Demanda
                    </label>
                    <div class="space-y-2">
                      <div 
                        v-for="anexo in anexos" 
                        :key="anexo.id"
                        class="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700 rounded-lg"
                      >
                        <div class="flex items-center gap-3 flex-1">
                          <svg class="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                          </svg>
                          <div class="flex-1 min-w-0">
                            <p class="text-sm font-medium text-gray-900 dark:text-white truncate">{{ anexo.nome }}</p>
                            <p v-if="anexo.usuario" class="text-xs text-gray-600 dark:text-gray-300 font-medium">Enviado por: {{ anexo.usuario }}</p>
                            <p v-if="anexo.descricao" class="text-xs text-gray-500 dark:text-gray-400">{{ anexo.descricao }}</p>
                            <p class="text-xs text-gray-500 dark:text-gray-400">{{ formatDate(anexo.data_upload) }}</p>
                          </div>
                        </div>
                        <button
                          @click="openAnexoModal(anexo)"
                          class="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors text-xs flex items-center justify-center"
                          title="Ver"
                        >
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Respostas do Jurídico (visualização) -->
                  <div v-if="respostasJuridico.length > 0" class="md:col-span-2">
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Respostas do Jurídico
                    </label>
                    <div class="space-y-2">
                      <div 
                        v-for="resposta in respostasJuridico" 
                        :key="resposta.id"
                        class="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700 rounded-lg"
                      >
                        <div class="flex items-center gap-3 flex-1">
                          <svg class="w-5 h-5 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                          </svg>
                          <div class="flex-1 min-w-0">
                            <p class="text-sm font-medium text-gray-900 dark:text-white truncate">{{ resposta.nome }}</p>
                            <p v-if="resposta.usuario" class="text-xs text-gray-600 dark:text-gray-300 font-medium">Enviado por: {{ resposta.usuario }}</p>
                            <p v-if="resposta.descricao" class="text-xs text-gray-500 dark:text-gray-400">{{ resposta.descricao }}</p>
                            <p class="text-xs text-gray-500 dark:text-gray-400">{{ formatDate(resposta.data_upload) }}</p>
                          </div>
                        </div>
                        <button
                          @click="openAnexoModal(resposta)"
                          class="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors text-xs flex items-center justify-center"
                          title="Ver"
                        >
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
              </div>
              </div>

            </div>

            <!-- Footer do Modal -->
            <div class="sticky bottom-0 z-20 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 p-4 sm:p-6 rounded-b-2xl shadow-sm">
              <!-- Mensagem quando demanda está cumprida -->
              <div v-if="isConcluido" class="flex items-center justify-center gap-3 p-4 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg">
                <svg class="w-6 h-6 text-yellow-600 dark:text-yellow-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
                <p class="text-sm sm:text-base text-yellow-800 dark:text-yellow-300 font-medium">
                  Esta demanda já foi marcada como cumprida. Só é possível visualizá-la.
                </p>
      
              </div>
              
              <!-- Botões quando demanda não está cumprida -->
              <div v-else class="flex gap-3">
                <button 
                  @click="closeModal"
                  class="flex-1 px-4 py-2.5 sm:px-6 sm:py-3 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-all font-medium text-xs sm:text-base md:text-lg"
                >
                  Cancelar
                </button>
                <button 
                  @click="saveChanges"
                  :disabled="isSaving"
                  class="flex-1 px-4 py-2.5 sm:px-6 sm:py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-all font-medium text-xs sm:text-base md:text-lg"
                >
                  <span v-if="!isSaving">Salvar Alterações</span>
                  <span v-else class="flex items-center justify-center">
                    <svg class="animate-spin -ml-1 mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Salvando...
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal de Visualização de Anexo -->
        <div v-if="showAnexoModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75 backdrop-blur-sm p-4">
          <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-6xl w-full max-h-[90vh] flex flex-col">
            <!-- Header do Modal -->
            <div class="sticky top-0 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 p-4 sm:p-6 rounded-t-2xl">
              <div class="flex justify-between items-center">
                <div>
                  <h2 class="text-xl font-bold text-gray-800 dark:text-white">{{ selectedAnexoView?.nome || 'Visualizar Documento' }}</h2>
                  <p v-if="selectedAnexoView?.usuario" class="text-sm text-gray-600 dark:text-gray-300 mt-1">Enviado por: {{ selectedAnexoView.usuario }}</p>
                  <p v-if="selectedAnexoView?.descricao" class="text-sm text-gray-600 dark:text-gray-300 mt-1">{{ selectedAnexoView.descricao }}</p>
                </div>
                <button 
                  @click="closeAnexoModal"
                  class="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
                >
                  <svg class="w-6 h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                  </svg>
                </button>
              </div>
            </div>

            <!-- Conteúdo do Modal -->
            <div class="flex-1 overflow-auto p-4 sm:p-6">
              <div v-if="selectedAnexoView?.url" class="w-full h-full">
                <!-- PDF Viewer -->
                <iframe 
                  v-if="isPdfFile(selectedAnexoView.url)"
                  :src="selectedAnexoView.url" 
                  class="w-full h-full min-h-[600px] border border-gray-300 dark:border-gray-600 rounded-lg"
                  frameborder="0"
                ></iframe>
                
                <!-- Image Viewer -->
                <div v-else-if="isImageFile(selectedAnexoView.url)" class="flex items-center justify-center">
                  <img 
                    :src="selectedAnexoView.url" 
                    alt="Imagem do anexo"
                    class="max-w-full h-auto max-h-[80vh] mx-auto rounded-lg shadow-lg"
                  >
                </div>
                
                <!-- Text Viewer -->
                <iframe 
                  v-else-if="isTextFile(selectedAnexoView.url)"
                  :src="selectedAnexoView.url" 
                  class="w-full h-full min-h-[600px] border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-900"
                  frameborder="0"
                ></iframe>
                
                <!-- Download para outros tipos de arquivo -->
                <div v-else class="flex flex-col items-center justify-center h-full min-h-[400px] text-center">
                  <svg class="w-24 h-24 text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                  </svg>
                  <p class="text-lg font-medium text-gray-700 dark:text-gray-300 mb-2">{{ selectedAnexoView.nome }}</p>
                  <p class="text-sm text-gray-500 dark:text-gray-400 mb-4">Este tipo de arquivo não pode ser visualizado no navegador</p>
                  <a 
                    :href="selectedAnexoView.url" 
                    target="_blank"
                    download
                    class="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
                  >
                    <svg class="w-5 h-5 inline-block mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path>
                    </svg>
                    Baixar Arquivo
                  </a>
                </div>
              </div>
              <div v-else class="flex items-center justify-center h-full min-h-[400px]">
                <p class="text-gray-500 dark:text-gray-400">Arquivo não disponível</p>
              </div>
            </div>

            <!-- Footer do Modal -->
            <div class="sticky bottom-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 p-4 sm:p-6 rounded-b-2xl">
              <div class="flex justify-between items-center">
                <div class="text-sm text-gray-600 dark:text-gray-400">
                  <p v-if="selectedAnexoView?.data_upload">Upload em: {{ formatDate(selectedAnexoView.data_upload) }}</p>
                  <p v-if="selectedAnexoView?.usuario">Por: {{ selectedAnexoView.usuario }}</p>
                </div>
                <div class="flex gap-3">
                  <a 
                    v-if="selectedAnexoView?.url"
                    :href="selectedAnexoView.url" 
                    target="_blank"
                    download
                    class="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors text-sm"
                  >
                    <svg class="w-4 h-4 inline-block mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path>
                    </svg>
                    Baixar
                  </a>
                  <button 
                    @click="closeAnexoModal"
                    class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm"
                  >
                    Fechar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal de Detalhes -->
        <div v-if="showDetailsModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm px-4 md:mt-14">
          <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-4xl w-full max-h-[80vh] overflow-y-auto">
            <!-- Header do Modal -->
            <div class="sticky top-0 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 p-4 sm:p-6 rounded-t-2xl">
              <div class="flex justify-between items-center">
                <div>
                  <h2 class="text-lg md:text-xl font-bold text-gray-800 dark:text-white">Detalhes da Demanda Judicial</h2>
                  <p class="text-sm text-gray-600 dark:text-gray-300">Protocolo: {{ selectedDemanda?.protocolo }}</p>
                </div>
                <button 
                  @click="closeDetailsModal"
                  class="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
                >
                  <svg class="w-6 h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                  </svg>
                </button>
              </div>
            </div>

            <!-- Conteúdo do Modal de Detalhes -->
            <div class="p-4 sm:p-6">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Protocolo
                  </label>
                  <div class="px-4 py-3 bg-gray-50 dark:bg-gray-700 rounded-lg text-gray-900 dark:text-white">
                    {{ selectedDemanda?.protocolo }}
                  </div>
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Nome da Demanda
                  </label>
                  <div class="px-4 py-3 bg-gray-50 dark:bg-gray-700 rounded-lg text-gray-900 dark:text-white">
                    {{ selectedDemanda?.nome_demanda || '-' }}
                  </div>
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Tipo de Demanda
                  </label>
                  <div class="px-4 py-3 bg-gray-50 dark:bg-gray-700 rounded-lg text-gray-900 dark:text-white">
                    {{ selectedDemanda?.tipo_demanda || '-' }}
                  </div>
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Número do Processo
                  </label>
                  <div class="px-4 py-3 bg-gray-50 dark:bg-gray-700 rounded-lg text-gray-900 dark:text-white">
                    {{ selectedDemanda?.numero_processo || '-' }}
                  </div>
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Tipo de Processo
                  </label>
                  <div class="px-4 py-3 bg-gray-50 dark:bg-gray-700 rounded-lg text-gray-900 dark:text-white">
                    {{ selectedDemanda?.tipo_processo || '-' }}
                  </div>
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Prazo de Entrega
                  </label>
                  <div class="px-4 py-3 bg-gray-50 dark:bg-gray-700 rounded-lg text-gray-900 dark:text-white">
                    {{ formatDate(selectedDemanda?.prazo_entrega) }}
                  </div>
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Data de Criação
                  </label>
                  <div class="px-4 py-3 bg-gray-50 dark:bg-gray-700 rounded-lg text-gray-900 dark:text-white">
                    {{ formatDate(selectedDemanda?.data_registro) }}
                  </div>
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Status
                  </label>
                  <div class="px-4 py-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                    <span :class="getStatusClass(selectedDemanda?.status)" class="px-2 py-1 text-xs font-medium rounded-full">
                      {{ selectedDemanda?.status || 'Pendente' }}
                    </span>
                  </div>
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Responsável pelo Registro
                  </label>
                  <div class="px-4 py-3 bg-gray-50 dark:bg-gray-700 rounded-lg text-gray-900 dark:text-white">
                    {{ selectedDemanda?.responsavel_registro || '-' }}
                  </div>
                </div>


                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Assunto
                  </label>
                  <div class="px-4 py-3 bg-gray-50 dark:bg-gray-700 rounded-lg text-gray-900 dark:text-white">
                    {{ selectedDemanda?.assunto ? selectedDemanda.assunto.nome : (selectedDemanda?.assunto_outro || '-') }}
                  </div>
                </div>

                <div class="md:col-span-2">
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Observações
                  </label>
                  <div class="px-4 py-3 bg-gray-50 dark:bg-gray-700 rounded-lg text-gray-900 dark:text-white">
                    {{ selectedDemanda?.observacoes || '-' }}
                  </div>
                </div>

                <!-- Informações do Paciente -->
                <div class="md:col-span-2 border-t border-gray-200 dark:border-gray-700 pt-4 mt-4">
                  <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                    Informações do Paciente
                  </h3>
                  
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                        Nome do Paciente
                  </label>
                  <div class="px-4 py-3 bg-gray-50 dark:bg-gray-700 rounded-lg text-gray-900 dark:text-white">
                        {{ selectedDemanda?.nome_paciente || '-' }}
                  </div>
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                        CPF do Paciente
                  </label>
                  <div class="px-4 py-3 bg-gray-50 dark:bg-gray-700 rounded-lg text-gray-900 dark:text-white">
                        {{ selectedDemanda?.cpf_paciente || '-' }}
                  </div>
                </div>

                    <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                        Data de Nascimento
                  </label>
                  <div class="px-4 py-3 bg-gray-50 dark:bg-gray-700 rounded-lg text-gray-900 dark:text-white">
                        {{ selectedDemanda?.data_nascimento_paciente ? new Date(selectedDemanda.data_nascimento_paciente).toLocaleDateString('pt-BR') : '-' }}
                  </div>
                </div>

                    <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                        Sexo
                  </label>
                  <div class="px-4 py-3 bg-gray-50 dark:bg-gray-700 rounded-lg text-gray-900 dark:text-white">
                        {{ selectedDemanda?.sexo_paciente === 'masculino' ? 'Masculino' : selectedDemanda?.sexo_paciente === 'feminino' ? 'Feminino' : selectedDemanda?.sexo_paciente === 'outro' ? 'Outro' : '-' }}
                      </div>
                  </div>
                </div>

                  <div class="mt-4">
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Outras Informações do Paciente
                  </label>
                    <div class="px-4 py-3 bg-gray-50 dark:bg-gray-700 rounded-lg text-gray-900 dark:text-white whitespace-pre-wrap">
                      {{ selectedDemanda?.outras_informacoes_paciente || '-' }}
                    </div>
                  </div>
                </div>

              <!-- Seção de Anexos no Modal de Detalhes -->
              <div v-if="selectedDemanda?.anexos?.length > 0 || selectedDemanda?.respostas_juridico?.length > 0 || selectedDemanda?.oficios?.length > 0" class="mt-8">
                <h3 class="text-lg font-semibold text-gray-800 dark:text-white mb-4">Documentos Anexados</h3>
                
                <!-- Anexos -->
                <div v-if="selectedDemanda?.anexos?.length > 0" class="mb-6">
                  <h4 class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">Anexos</h4>
                  <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div v-for="anexo in selectedDemanda.anexos" :key="anexo.id"
                      class="bg-gray-50 dark:bg-gray-700 rounded-lg p-3 flex items-center justify-between space-x-3 shadow-sm">
                      <div class="flex items-center space-x-3 flex-1 min-w-0">
                        <svg class="w-5 h-5 text-blue-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd"
                            d="M4 4a2 2 0 012-2h4.586A2 2 0 0113 3.414L16.586 7A2 2 0 0118 8.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm0 4a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1z"
                            clip-rule="evenodd"></path>
                        </svg>
                        <div class="flex-1 min-w-0">
                          <span class="text-blue-600 dark:text-blue-400 truncate text-sm block">{{ anexo.nome }}</span>
                          <span v-if="anexo.usuario" class="text-xs text-gray-600 dark:text-gray-300">Enviado por: {{ anexo.usuario }}</span>
                        </div>
                      </div>
                      <button
                        @click="openAnexoModal(anexo)"
                        class="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors text-xs flex-shrink-0"
                      >
                        Ver
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Respostas do Jurídico -->
                <div v-if="selectedDemanda?.respostas_juridico?.length > 0" class="mb-6">
                  <h4 class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">Respostas do Jurídico</h4>
                  <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div v-for="resposta in selectedDemanda.respostas_juridico" :key="resposta.id"
                      class="bg-gray-50 dark:bg-gray-700 rounded-lg p-3 flex items-center justify-between space-x-3 shadow-sm">
                      <div class="flex items-center space-x-3 flex-1 min-w-0">
                        <svg class="w-5 h-5 text-purple-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd"
                            d="M4 4a2 2 0 012-2h4.586A2 2 0 0113 3.414L16.586 7A2 2 0 0118 8.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm0 4a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1z"
                            clip-rule="evenodd"></path>
                        </svg>
                        <div class="flex-1 min-w-0">
                          <span class="text-purple-600 dark:text-purple-400 truncate text-sm block">{{ resposta.nome }}</span>
                          <span v-if="resposta.usuario" class="text-xs text-gray-600 dark:text-gray-300">Enviado por: {{ resposta.usuario }}</span>
                        </div>
                      </div>
                      <button
                        @click="openAnexoModal(resposta)"
                        class="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors text-xs flex-shrink-0"
                      >
                        Ver
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Ofícios -->
                <div v-if="selectedDemanda?.oficios?.length > 0" class="mb-6">
                  <h4 class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">Ofícios</h4>
                  <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div v-for="oficio in selectedDemanda.oficios" :key="oficio.id"
                      class="bg-gray-50 dark:bg-gray-700 rounded-lg p-3 flex items-center justify-between space-x-3 shadow-sm">
                      <div class="flex items-center space-x-3 flex-1 min-w-0">
                        <svg class="w-5 h-5 text-green-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd"
                            d="M4 4a2 2 0 012-2h4.586A2 2 0 0113 3.414L16.586 7A2 2 0 0118 8.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm0 4a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1z"
                            clip-rule="evenodd"></path>
                        </svg>
                        <div class="flex-1 min-w-0">
                          <span class="text-green-600 dark:text-green-400 truncate text-sm block">{{ oficio.nome }}</span>
                          <span v-if="oficio.usuario" class="text-xs text-gray-600 dark:text-gray-300">Enviado por: {{ oficio.usuario }}</span>
                        </div>
                      </div>
                      <button
                        @click="openAnexoModal(oficio)"
                        class="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors text-xs flex-shrink-0"
                      >
                        Ver
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Footer do Modal de Detalhes -->
            <div class="sticky bottom-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 p-4 sm:p-6 rounded-b-2xl">
              <button 
                @click="closeDetailsModal"
                class="w-full px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all font-medium"
              >
                Fechar
              </button>
            </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </BaseTemplate>

  <!-- Modal de Email Customizado -->
  <div v-if="showEmailCustomizadoModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4">
    <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-md w-full">
      <div class="p-6">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-xl font-bold text-gray-800 dark:text-white">Adicionar E-mail Customizado</h3>
          <button
            @click="showEmailCustomizadoModal = false"
            class="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
          >
            <svg class="w-6 h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        
        <div class="space-y-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              E-mail <span class="text-red-500">*</span>
            </label>
            <input
              v-model="novoEmailCustomizado.email"
              type="email"
              class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="exemplo@email.com"
              required
            >
          </div>
          
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Nome (opcional)
            </label>
            <input
              v-model="novoEmailCustomizado.nome"
              type="text"
              class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Nome para identificação"
            >
          </div>
          
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Descrição (opcional)
            </label>
            <textarea
              v-model="novoEmailCustomizado.descricao"
              rows="2"
              class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
              placeholder="Descrição do e-mail"
            ></textarea>
          </div>
        </div>
        
        <div class="flex gap-3 mt-6">
          <button
            @click="showEmailCustomizadoModal = false"
            class="flex-1 px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
          >
            Cancelar
          </button>
          <button
            @click="criarEmailCustomizado"
            class="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Salvar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Banner de Sucesso -->
  <Transition enter-active-class="transition-all duration-300 ease-out" leave-active-class="transition-all duration-300 ease-in" enter-from-class="translate-x-full opacity-0" leave-to-class="translate-x-full opacity-0">
    <div v-if="showSuccessBanner" class="fixed top-4 right-4 z-50">
      <div class="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg shadow-lg p-4 max-w-md">
        <div class="flex items-center gap-3">
          <div class="flex-shrink-0 w-8 h-8 bg-green-100 dark:bg-green-900/40 rounded-full flex items-center justify-center">
            <svg class="w-5 h-5 text-green-600 dark:text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div class="flex-1">
            <p class="text-sm font-medium text-green-800 dark:text-green-300">
              {{ successMessage }}
            </p>
          </div>
          <button
            @click="showSuccessBanner = false"
            class="flex-shrink-0 text-green-600 dark:text-green-400 hover:text-green-800 dark:hover:text-green-300 transition-colors"
          >
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </Transition>

  <!-- Modal de Erro de Email -->
  <div v-if="showErrorBanner" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4">
    <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-md w-full">
      <div class="p-6">
        <div class="flex items-center gap-4 mb-4">
          <div class="flex-shrink-0 w-12 h-12 bg-red-100 dark:bg-red-900/20 rounded-full flex items-center justify-center">
            <svg class="w-6 h-6 text-red-600 dark:text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
            </svg>
          </div>
          <div>
            <h3 class="text-lg font-bold text-gray-800 dark:text-white">Erro ao Enviar E-mail</h3>
            <p class="text-sm text-gray-600 dark:text-gray-300">Aviso sobre o envio de e-mail</p>
          </div>
        </div>
        <p class="text-gray-700 dark:text-gray-300 mb-6">
          {{ errorMessage }}
        </p>
        <div class="flex justify-end gap-3">
          <button
            @click="reenviarEmail"
            :disabled="isReenviandoEmail"
            class="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-all font-medium flex items-center gap-2"
          >
            <svg v-if="!isReenviandoEmail" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
            </svg>
            <svg v-else class="w-5 h-5 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
            </svg>
            {{ isReenviandoEmail ? 'Reenviando...' : 'Reenviar E-mail' }}
          </button>
          <button
            @click="showErrorBanner = false"
            class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all font-medium"
          >
            Entendi
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal de Aviso de Permissão -->
  <div v-if="showPermissionModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4">
    <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-md w-full">
      <div class="p-6">
        <div class="flex items-center gap-4 mb-4">
          <div class="flex-shrink-0 w-12 h-12 bg-yellow-100 dark:bg-yellow-900/20 rounded-full flex items-center justify-center">
            <svg class="w-6 h-6 text-yellow-600 dark:text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
            </svg>
          </div>
          <div>
            <h3 class="text-lg font-bold text-gray-800 dark:text-white">Permissão Insuficiente</h3>
            <p class="text-sm text-gray-600 dark:text-gray-300">Você não tem permissão para realizar esta ação</p>
          </div>
        </div>
        <p class="text-gray-700 dark:text-gray-300 mb-6">
          O seu tipo de <strong>permissão</strong> pode apenas criar demandas e visualizar detalhes. Para editar demandas, é necessário ter permissões de administrador.
        </p>
        <div class="flex justify-end">
          <button
            @click="showPermissionModal = false"
            class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all font-medium"
          >
            Entendi
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted, onUnmounted, computed, watch, nextTick } from 'vue'
import BaseTemplate from '../templates/BaseTemplate.vue'
import apiClient from '@/services/authService.js'
import { useUserStore } from '@/stores/userStore.js'
import { usePerfilStore } from '@/stores/settings/perfilStore.js'
import Chart from 'chart.js/auto'
import jsPDF from 'jspdf'

// Stores
const userStore = useUserStore()
const perfilStore = usePerfilStore()

// Estados reativos
const demandas = ref([])
const searchTerm = ref('')
const selectedStatus = ref('todos')
const itemsPerPage = ref('10')
const currentPage = ref(1)
const totalItems = ref(0)
const totalPages = ref(0)
const showModal = ref(false)
const showDetailsModal = ref(false)
const showCreateModal = ref(false)
const selectedDemanda = ref(null)
const currentPhase = ref(1)
const isSaving = ref(false)
const isCreating = ref(false)
// Tema alinhado ao BaseTemplate (usa a mesma chave 'darkMode')
const isDark = ref(typeof localStorage !== 'undefined' && localStorage.getItem('darkMode') === 'true')
const juridicoUsers = ref([])
const allUsers = ref([])
const anexos = ref([])
const respostasJuridico = ref([])
const oficios = ref([])
const uploadingAnexo = ref(false)
const selectedFile = ref(null)
const selectedRespostaJuridicoFile = ref(null)
const showAnexoModal = ref(false)
const selectedAnexoView = ref(null)
const emailsCustomizados = ref([])
const showEmailCustomizadoModal = ref(false)
const novoEmailCustomizado = reactive({
  email: '',
  nome: '',
  descricao: ''
})
const novoDestinatarioJuridicoEtapa2 = ref('')
const novoDestinatarioSms = ref('')
const fase4Completa = ref(false)
const selectedOficioFile = ref(null)
const anexosParaCriacao = ref([])
const uploadingAnexoCriacao = ref(false)

// Função para verificar se o usuário pode deletar o anexo
// eslint-disable-next-line no-unused-vars
const podeDeletarAnexo = (anexo) => {
  // Desabilitado: após anexar um documento, não é mais possível excluí-lo, apenas visualizar
  return false
  
  // Código antigo (desabilitado):
  // if (!anexo || !anexo.usuario) return false
  // 
  // // Obter nome completo do usuário atual
  // const nomeCompleto = perfilStore.firstName && perfilStore.lastName 
  //   ? `${perfilStore.firstName} ${perfilStore.lastName}`.trim()
  //   : userStore.nome || ''
  // 
  // // Verificar se o usuário atual é o mesmo que enviou o arquivo ou se é admin
  // const podeDeletar = anexo.usuario === nomeCompleto || 
  //                     anexo.usuario === userStore.nome ||
  //                     userStore.grupos?.includes('juridico_admin') || 
  //                     userStore.grupos?.includes('superadmin')
  // return podeDeletar
}

// Estados de controle de fases
const fase2Completa = ref(false)
const fase3Completa = ref(false)
const isConcluido = ref(false)

// Fases do modal
const fases = [
  { id: 1, name: 'Etapa 1 - Registro' },
  { id: 2, name: 'Etapa 2 - Triagem' },
  { id: 3, name: 'Etapa 3 - Resposta do Jurídico' },
  { id: 4, name: 'Etapa 4 - Envio para SMS' }
]

// Formulário do modal
const modalForm = reactive({
  // Etapa 2 - Triagem
  dataInicioTriagem: '',
  dataDevolucaoTriagem: '',
  responsavelTriagem: '',
  prioridade: '',
  analiseTriagem: '',
  mensagemEmailJuridicoEtapa2: '',
  enviarEmailJuridicoEtapa2: false,
  destinatariosEmailJuridicoEtapa2: [],
  
  // Etapa 3 - Resposta do Jurídico
  dataRecebimentoRespostaJuridico: '',
  respostaJuridico: '',
  responsavelRecebimentoJuridico: '',
  
  // Etapa 4 - Envio para SMS
  dataPreparacaoOficio: '',
  responsavelOficio: '',
  dataEnvioJudiciario: '',
  responsavelEnvio: '',
  metodoEnvio: '',
  mensagemEmailSms: '',
  enviarEmailSms: false,
  destinatariosEmailSms: [],
  
  statusFinal: ''
})

const createForm = reactive({
  nome_demanda: '',
  tipo_demanda: '',
  numero_processo: '',
  tipo_processo: '',
  prazo_entrega: '',
  responsavel_registro: '',
  responsavel_triagem: '',
  enviar_email_triagem: false,
  mensagem_email_triagem: '',
  observacoes: '',
  assunto_id: null,
  assunto_outro: '',
  // Informações do Paciente
  nome_paciente: '',
  cpf_paciente: '',
  data_nascimento_paciente: '',
  sexo_paciente: '',
  outras_informacoes_paciente: '',
})

const showPermissionModal = ref(false)
const showSuccessBanner = ref(false)
const successMessage = ref('')
const showErrorBanner = ref(false)
const errorMessage = ref('')
const erroEmailFase = ref(null) // Armazena qual fase teve erro de email
const payloadErroEmail = ref(null) // Armazena o payload para reenvio
const isReenviandoEmail = ref(false)
const assuntos = ref([])

// Gráficos e Relatórios
const showGraficosRelatorios = ref(false)
const graficosRelatoriosTab = ref('graficos')
const carregandoGraficos = ref(false)
const carregandoRelatorio = ref(false)
const dadosGraficos = ref({})
const dadosRelatorio = ref({ demandas: [] })
const filtrosGrafico = reactive({
  data_inicio: '',
  data_fim: '',
  tipo_processo: '',
  tipo_demanda: '',
  status: '',
  assunto_id: null
})
const filtrosRelatorio = reactive({
  status: '',
  data_inicio: '',
  data_fim: '',
  tipo_processo: '',
  tipo_demanda: '',
  assunto_id: null,
  prazo_vencido: null
})

// Referências para os canvas dos gráficos
const chartTipoProcesso = ref(null)
const chartTipoDemanda = ref(null)
const chartPrazoEntrega = ref(null)
const chartAssunto = ref(null)
let chartInstances = {
  tipoProcesso: null,
  tipoDemanda: null,
  prazoEntrega: null,
  assunto: null
}

// Funções de paginação




// Demandas filtradas (agora apenas retorna as demandas carregadas, pois a filtragem é feita no backend)
const filteredDemandas = computed(() => demandas.value)

// Computed para controle de fases
const isFaseReadOnly = (faseNumero) => {
    // Se o usuário não tem permissão para editar, todas as fases são somente leitura
    if (!podeEditar.value) {
      return true
    }
    // Se estiver concluído, todas as fases são somente leitura
    if (isConcluido.value) {
      return true
    }
    // Verificar se a fase está disponível
    return !isFaseDisponivel(faseNumero)
  }

const isFaseDisponivel = (faseNumero) => {
  switch(faseNumero) {
    case 1:
      return true // Fase 1 sempre disponível
    case 2:
      return true // Fase 2 sempre disponível
    case 3:
      return fase2Completa.value // Fase 3 só disponível se fase 2 estiver completa
    case 4:
      return fase3Completa.value // Fase 4 só disponível se fase 3 estiver completa
    default:
      return false
  }
}

// Funções de paginação
const previousPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--
    loadDemandas()
  }
}

const nextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++
    loadDemandas()
  }
}

const loadDemandas = async () => {
  try {
    const params = {
      page: currentPage.value,
      per_page: parseInt(itemsPerPage.value),
      search: searchTerm.value || undefined,
      status: selectedStatus.value !== 'todos' ? selectedStatus.value : undefined
    }
    
    const response = await apiClient.get('/api/v1/juridico/gerenciar/', { params })
    const data = response.data
    demandas.value = data.demandas.map(demanda => ({
      id: demanda.id,
      protocolo: demanda.protocolo,
      nome_demanda: demanda.nome_demanda,
      numero_processo: demanda.numero_processo,
      tipo_processo: demanda.tipo_processo,
      prazo_entrega: demanda.prazo_entrega,
      data_registro: demanda.data_registro,
      status: demanda.status || 'Pendente',
      prioridade: demanda.prioridade || ''
    }))
    totalItems.value = Number(data.total) || demandas.value.length || 0
    totalPages.value = Number(data.pages) || Math.ceil(totalItems.value / parseInt(itemsPerPage.value)) || 1
  } catch (error) {
    console.error('Erro ao carregar demandas:', error)
    demandas.value = []
  }
}

const loadJuridicoUsers = async () => {
  try {
    const response = await apiClient.get('/api/v1/auth/users/')
    const usersData = response.data || []
    
    // Mapear todos os usuários
    allUsers.value = usersData.map(user => ({
      id: user.id,
      nome: `${user.first_name} ${user.last_name}`.trim() || user.username,
      email: user.email,
      username: user.username
    }))
    
    // Filter users that belong to the 'juridico' or 'juridico_admin' groups
    juridicoUsers.value = usersData.filter(user => 
      user.groups && (user.groups.includes('juridico') || user.groups.includes('juridico_admin'))
    ).map(user => ({
      id: user.id,
      name: `${user.first_name} ${user.last_name}`.trim() || user.username,
      email: user.email,
      username: user.username
    }))
  } catch (error) {
    console.error('Erro ao carregar usuários:', error)
    juridicoUsers.value = []
    allUsers.value = []
  }
}

const loadEmailsCustomizados = async () => {
  try {
    const response = await apiClient.get('/api/v1/juridico/emails-customizados/')
    emailsCustomizados.value = response.data
  } catch (error) {
    console.error('Erro ao carregar emails customizados:', error)
    emailsCustomizados.value = []
  }
}

const loadAssuntos = async () => {
  try {
    const response = await apiClient.get('/api/v1/juridico/assuntos/')
    assuntos.value = response.data || []
  } catch (error) {
    console.error('Erro ao carregar assuntos:', error)
    assuntos.value = []
  }
}


const criarEmailCustomizado = async () => {
  if (!novoEmailCustomizado.email) {
    alert('Por favor, informe o e-mail')
    return
  }
  
  // Validar formato de email
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (!emailRegex.test(novoEmailCustomizado.email)) {
    alert('Por favor, informe um e-mail válido')
    return
  }
  
  try {
    const response = await apiClient.post('/api/v1/juridico/emails-customizados/', novoEmailCustomizado)
    emailsCustomizados.value.push(response.data)
    novoEmailCustomizado.email = ''
    novoEmailCustomizado.nome = ''
    novoEmailCustomizado.descricao = ''
    showEmailCustomizadoModal.value = false
    // Mostrar banner de sucesso
    successMessage.value = 'E-mail customizado criado com sucesso!'
    showSuccessBanner.value = true
    // Fechar banner automaticamente após 3 segundos
    setTimeout(() => {
      showSuccessBanner.value = false
    }, 3000)
  } catch (error) {
    console.error('Erro ao criar email customizado:', error)
    alert('Erro ao criar email customizado. Tente novamente.')
  }
}

const handleEmailJuridicoEtapa2Change = () => {
  if (modalForm.enviarEmailJuridicoEtapa2 && !modalForm.mensagemEmailJuridicoEtapa2) {
    modalForm.mensagemEmailJuridicoEtapa2 = `${userStore.nome || 'Usuário'} enviou um email com as informações da demanda e o prazo para conclusão`
  }
}

const adicionarDestinatarioJuridicoEtapa2 = () => {
  if (novoDestinatarioJuridicoEtapa2.value && !modalForm.destinatariosEmailJuridicoEtapa2.includes(novoDestinatarioJuridicoEtapa2.value)) {
    modalForm.destinatariosEmailJuridicoEtapa2.push(novoDestinatarioJuridicoEtapa2.value)
    novoDestinatarioJuridicoEtapa2.value = ''
  }
}

const removerDestinatarioJuridicoEtapa2 = (index) => {
  modalForm.destinatariosEmailJuridicoEtapa2.splice(index, 1)
}

const adicionarDestinatarioSms = () => {
  if (novoDestinatarioSms.value && !modalForm.destinatariosEmailSms.includes(novoDestinatarioSms.value)) {
    modalForm.destinatariosEmailSms.push(novoDestinatarioSms.value)
    novoDestinatarioSms.value = ''
  }
}

const removerDestinatarioSms = (index) => {
  modalForm.destinatariosEmailSms.splice(index, 1)
}

const handleEmailSmsChange = () => {
  if (modalForm.enviarEmailSms && !modalForm.mensagemEmailSms) {
    modalForm.mensagemEmailSms = 'O ofício da demanda está pronto para envio à SMS.'
  }
}


const formatarCPF = (event) => {
  let value = event.target.value.replace(/\D/g, '') // Remove tudo que não é dígito
  if (value.length <= 11) {
    // Aplica a máscara 000.000.000-00
    value = value.replace(/(\d{3})(\d)/, '$1.$2')
    value = value.replace(/(\d{3})(\d)/, '$1.$2')
    value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2')
    createForm.cpf_paciente = value
  }
}

const formatDate = (dateString) => {
  if (!dateString) return '-'
  const date = new Date(dateString)
  return date.toLocaleDateString('pt-BR')
}

const getStatusClass = (status) => {
  const classes = {
    'Pendente': 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300',
    'Em Triagem': 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300',
    'Aguardando Jurídico': 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900 dark:text-indigo-300',
    'Cumprido': 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
    'Arquivado': 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-300'
  }
  return classes[status] || classes['Pendente']
}

const verificarFaseCompleta = (faseNumero) => {
  switch(faseNumero) {
    case 2:
      return !!(
        modalForm.dataInicioTriagem &&
        modalForm.responsavelTriagem &&
        modalForm.prioridade &&
        modalForm.analiseTriagem
      )
    case 3:
      return !!(
        modalForm.dataRecebimentoRespostaJuridico &&
        modalForm.responsavelRecebimentoJuridico
      )
    case 4:
      return !!(
        modalForm.dataPreparacaoOficio &&
        modalForm.responsavelOficio &&
        modalForm.dataEnvioJudiciario
      )
    default:
      return false
  }
}

const openModal = async (demanda) => {
  // Verificar permissões antes de abrir o modal
  if (!podeEditar.value) {
    showPermissionModal.value = true
    return
  }
  
  selectedDemanda.value = demanda
  currentPhase.value = 1
  
  try {
    const response = await apiClient.get(`/api/v1/juridico/${demanda.id}/gerenciar/`)
    const data = response.data
 
    selectedDemanda.value = {
      ...demanda,
      ...data
    }
    
    anexos.value = data.anexos || []
    respostasJuridico.value = data.respostas_juridico || []
    oficios.value = data.oficios || []

    modalForm.dataInicioTriagem = data.data_inicio_triagem || ''
    modalForm.dataDevolucaoTriagem = data.data_devolucao_triagem || ''
    modalForm.responsavelTriagem = data.responsavel_triagem || ''
    modalForm.prioridade = data.prioridade || ''
    modalForm.analiseTriagem = data.analise_triagem || ''
    modalForm.mensagemEmailJuridicoEtapa2 = data.mensagem_email_juridico_etapa2 || ''
    modalForm.enviarEmailJuridicoEtapa2 = data.email_enviado_juridico_etapa2 || false
    // Carregar destinatários da etapa 2
    if (data.destinatarios_email_juridico_etapa2) {
      if (Array.isArray(data.destinatarios_email_juridico_etapa2)) {
        modalForm.destinatariosEmailJuridicoEtapa2 = data.destinatarios_email_juridico_etapa2
      } else if (typeof data.destinatarios_email_juridico_etapa2 === 'string' && data.destinatarios_email_juridico_etapa2.includes(',')) {
        modalForm.destinatariosEmailJuridicoEtapa2 = data.destinatarios_email_juridico_etapa2.split(',').map(e => e.trim()).filter(e => e)
      } else {
        modalForm.destinatariosEmailJuridicoEtapa2 = [data.destinatarios_email_juridico_etapa2]
      }
    } else {
      modalForm.destinatariosEmailJuridicoEtapa2 = []
    }
    
    if (data.email_erro_juridico_etapa2) {
      erroEmailFase.value = 2
      payloadErroEmail.value = {
        enviar_email_juridico_etapa2: true,
        mensagem_email_juridico_etapa2: data.mensagem_email_juridico_etapa2 || '',
        destinatarios_email_juridico_etapa2: modalForm.destinatariosEmailJuridicoEtapa2
      }
    }
    
    // Etapa 3 - Resposta do Jurídico
    modalForm.dataRecebimentoRespostaJuridico = data.data_recebimento_resposta_juridico || ''
    modalForm.respostaJuridico = data.resposta_juridico || ''
    modalForm.responsavelRecebimentoJuridico = data.responsavel_recebimento_juridico || ''
    
    // Etapa 4 - Envio para SMS
    modalForm.dataPreparacaoOficio = data.data_preparacao_oficio || ''
    modalForm.responsavelOficio = data.responsavel_oficio || ''
    modalForm.dataEnvioJudiciario = data.data_envio_judiciario || ''
    modalForm.responsavelEnvio = data.responsavel_envio || ''
    modalForm.metodoEnvio = data.metodo_envio || ''
    modalForm.mensagemEmailSms = data.mensagem_email_sms || ''
    modalForm.enviarEmailSms = data.email_enviado_sms || false
    
    // Carregar destinatários da etapa 4
    if (data.destinatarios_email_sms) {
      if (Array.isArray(data.destinatarios_email_sms)) {
        modalForm.destinatariosEmailSms = data.destinatarios_email_sms
      } else if (typeof data.destinatarios_email_sms === 'string' && data.destinatarios_email_sms.includes(',')) {
        modalForm.destinatariosEmailSms = data.destinatarios_email_sms.split(',').map(e => e.trim()).filter(e => e)
      } else {
        modalForm.destinatariosEmailSms = [data.destinatarios_email_sms]
      }
    } else {
      modalForm.destinatariosEmailSms = []
    }
    
    // Carregar flags de erro de email etapa 4
    if (data.email_erro_sms) {
      erroEmailFase.value = 4
      payloadErroEmail.value = {
        enviar_email_sms: true,
        mensagem_email_sms: data.mensagem_email_sms || '',
        destinatarios_email_sms: modalForm.destinatariosEmailSms
      }
    }
    
    modalForm.statusFinal = data.status || 'Pendente'
    
    // Verificar estado das fases
    isConcluido.value = data.status === 'Cumprido'
    fase2Completa.value = verificarFaseCompleta(2)
    fase3Completa.value = verificarFaseCompleta(3)
    fase4Completa.value = verificarFaseCompleta(4)
    
    // Ajustar fase inicial baseado no progresso
    if (isConcluido.value) {
      currentPhase.value = 4
    } else if (fase3Completa.value) {
      currentPhase.value = 4
    } else if (fase2Completa.value) {
      currentPhase.value = 3
    } else if (data.status === 'Pendente') {
      currentPhase.value = 1
    } else {
      currentPhase.value = 2
    }
    
  } catch (error) {
    console.error('Erro ao carregar detalhes:', error)
    // Resetar formulário em caso de erro
    Object.keys(modalForm).forEach(key => {
      if (typeof modalForm[key] === 'boolean') {
        modalForm[key] = false
      } else {
      modalForm[key] = ''
      }
    })
  }
  
  showModal.value = true
}

const closeModal = () => {
  showModal.value = false
  selectedDemanda.value = null
  // Resetar arrays de destinatários
  // Limpar flags de erro
  erroEmailFase.value = null
  payloadErroEmail.value = null
  modalForm.destinatariosEmailJuridicoEtapa2 = []
  modalForm.destinatariosEmailSms = []
  novoDestinatarioJuridicoEtapa2.value = ''
  novoDestinatarioSms.value = ''
  currentPhase.value = 1
  anexos.value = []
  respostasJuridico.value = []
  oficios.value = []
  selectedFile.value = null
  selectedRespostaJuridicoFile.value = null
  selectedOficioFile.value = null
}

const handleFileSelect = (event) => {
  const file = event.target.files[0]
  if (file) {
    selectedFile.value = file
  }
}

const handleRespostaJuridicoSelect = (event) => {
  const file = event.target.files[0]
  if (file) {
    selectedRespostaJuridicoFile.value = file
  }
}

const handleOficioSelect = (event) => {
  const file = event.target.files[0]
  if (file) {
    selectedOficioFile.value = file
  }
}


const uploadAnexo = async (etapa, descricao) => {
  if (!selectedFile.value || !selectedDemanda.value) return
  
  uploadingAnexo.value = true
  try {
    const formData = new FormData()
    formData.append('arquivo', selectedFile.value)
    formData.append('nome', selectedFile.value.name)
    formData.append('etapa', etapa)
    formData.append('descricao', descricao)
    const response = await apiClient.post(
      `/api/v1/juridico/${selectedDemanda.value.id}/anexo/`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    
    anexos.value.push(response.data)
    selectedFile.value = null
    // Reset file input
    const inputs = document.querySelectorAll('input[type="file"]')
    inputs.forEach(input => {
      if (input.id.includes('anexo-upload')) {
        input.value = ''
      }
    })
  } catch (error) {
    console.error('Erro ao fazer upload do anexo:', error)
    alert('Erro ao fazer upload do anexo. Tente novamente.')
  } finally {
    uploadingAnexo.value = false
  }
}

const uploadRespostaJuridico = async () => {
  if (!selectedRespostaJuridicoFile.value || !selectedDemanda.value) return
  
  uploadingAnexo.value = true
  try {
    const formData = new FormData()
    formData.append('arquivo', selectedRespostaJuridicoFile.value)
    formData.append('nome', selectedRespostaJuridicoFile.value.name)
    
    const response = await apiClient.post(
      `/api/v1/juridico/${selectedDemanda.value.id}/resposta-juridico/`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    
    respostasJuridico.value.push(response.data)
    selectedRespostaJuridicoFile.value = null
    // Reset file input
    const input = document.getElementById('resposta-juridico-upload')
    if (input) input.value = ''
  } catch (error) {
    console.error('Erro ao fazer upload da resposta do jurídico:', error)
    alert('Erro ao fazer upload da resposta do jurídico. Tente novamente.')
  } finally {
    uploadingAnexo.value = false
  }
}

const uploadOficio = async () => {
  if (!selectedOficioFile.value || !selectedDemanda.value) return
  
  uploadingAnexo.value = true
  try {
    const formData = new FormData()
    formData.append('arquivo', selectedOficioFile.value)
    formData.append('nome', selectedOficioFile.value.name)
    
    const response = await apiClient.post(
      `/api/v1/juridico/${selectedDemanda.value.id}/oficio/`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    
    oficios.value.push(response.data)
    selectedOficioFile.value = null
    // Reset file input
    const input = document.getElementById('oficio-upload')
    if (input) input.value = ''
  } catch (error) {
    console.error('Erro ao fazer upload do ofício:', error)
    alert('Erro ao fazer upload do ofício. Tente novamente.')
  } finally {
    uploadingAnexo.value = false
  }
}


const deletarAnexo = async (anexoId) => {
  if (!confirm('Tem certeza que deseja excluir este anexo?')) return
  
  try {
    await apiClient.delete(`/api/v1/juridico/anexo/${anexoId}/`)
    anexos.value = anexos.value.filter(a => a.id !== anexoId)
  } catch (error) {
    console.error('Erro ao deletar anexo:', error)
    alert('Erro ao deletar anexo. Tente novamente.')
  }
}

const openAnexoModal = (anexo) => {
  selectedAnexoView.value = anexo
  showAnexoModal.value = true
}

const closeAnexoModal = () => {
  showAnexoModal.value = false
  selectedAnexoView.value = null
}

const isPdfFile = (url) => {
  if (!url) return false
  const urlLower = url.toLowerCase()
  // Verifica se termina com .pdf ou contém .pdf na URL
  if (urlLower.endsWith('.pdf') || urlLower.includes('.pdf?') || urlLower.includes('.pdf&')) {
    return true
  }
  // Verifica também pelo nome do arquivo se disponível
  if (selectedAnexoView.value?.nome) {
    return selectedAnexoView.value.nome.toLowerCase().endsWith('.pdf')
  }
  return false
}

const isImageFile = (url) => {
  if (!url) return false
  const urlLower = url.toLowerCase()
  const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg']
  
  // Verifica extensão na URL
  for (const ext of imageExtensions) {
    const index = urlLower.indexOf(ext)
    if (index !== -1) {
      const afterExt = urlLower.substring(index + ext.length)
      if (afterExt === '' || afterExt.startsWith('?') || afterExt.startsWith('&')) {
        return true
      }
    }
  }
  
  // Verifica também pelo nome do arquivo se disponível
  if (selectedAnexoView.value?.nome) {
    const nomeLower = selectedAnexoView.value.nome.toLowerCase()
    return imageExtensions.some(ext => nomeLower.endsWith(ext))
  }
  
  return false
}

const isTextFile = (url) => {
  if (!url) return false
  const urlLower = url.toLowerCase()
  const textExtensions = ['.txt', '.csv', '.log', '.md', '.json', '.xml', '.html', '.htm', '.css', '.js']
  
  // Verifica extensão na URL
  for (const ext of textExtensions) {
    const index = urlLower.indexOf(ext)
    if (index !== -1) {
      const afterExt = urlLower.substring(index + ext.length)
      if (afterExt === '' || afterExt.startsWith('?') || afterExt.startsWith('&')) {
        return true
      }
    }
  }
  
  // Verifica também pelo nome do arquivo se disponível
  if (selectedAnexoView.value?.nome) {
    const nomeLower = selectedAnexoView.value.nome.toLowerCase()
    return textExtensions.some(ext => nomeLower.endsWith(ext))
  }
  
  return false
}

const getCurrentUserName = () => {
  if (perfilStore.firstName && perfilStore.lastName) {
    return `${perfilStore.firstName} ${perfilStore.lastName}`.trim()
  }
  return userStore.nome || ''
}

const podeEditar = computed(() => {
  // Apenas usuários do grupo juridico_admin podem editar
  // Se o usuário estiver apenas no grupo juridico (sem juridico_admin), não pode editar
  const grupos = userStore.grupos || []
  const temJuridicoAdmin = grupos.includes('juridico_admin')
  const temApenasJuridico = grupos.includes('juridico') && !temJuridicoAdmin
  
  // Se tiver apenas juridico (sem juridico_admin), não pode editar
  if (temApenasJuridico) {
    return false
  }
  
  // Caso contrário, permite se for juridico_admin ou superadmin
  return temJuridicoAdmin || grupos.includes('superadmin')
})

const openCreateModal = () => {
  showCreateModal.value = true
  // Reset form
  createForm.nome_demanda = ''
  createForm.tipo_demanda = ''
  createForm.numero_processo = ''
  createForm.tipo_processo = ''
  createForm.prazo_entrega = ''
  createForm.responsavel_registro = getCurrentUserName()
  createForm.responsavel_triagem = ''
  createForm.enviar_email_triagem = false
  createForm.mensagem_email_triagem = ''
  createForm.observacoes = ''
  createForm.assunto_id = null
  createForm.assunto_outro = ''
  // Reset informações do paciente
  createForm.nome_paciente = ''
  createForm.cpf_paciente = ''
  createForm.data_nascimento_paciente = ''
  createForm.sexo_paciente = ''
  createForm.outras_informacoes_paciente = ''
}

const closeCreateModal = () => {
  showCreateModal.value = false
  anexosParaCriacao.value = []
  uploadingAnexoCriacao.value = false
}

const handleEmailTriagemChange = () => {
  if (createForm.enviar_email_triagem && !createForm.mensagem_email_triagem) {
    createForm.mensagem_email_triagem = `Olá, você foi designado como responsável pela triagem da demanda judicial. Acesse o sistema para iniciar a triagem.`
  }
}

const adicionarAnexoCriacao = (event) => {
  const files = event.target.files
  if (files && files.length > 0) {
    for (let i = 0; i < files.length; i++) {
      anexosParaCriacao.value.push({
        file: files[i],
        nome: files[i].name,
        id: Date.now() + i // ID temporário
      })
    }
    // Limpar input
    event.target.value = ''
  }
}

const removerAnexoCriacao = (index) => {
  anexosParaCriacao.value.splice(index, 1)
}

const createDemanda = async () => {
  isCreating.value = true
  try {
    const payload = {
      nome_demanda: createForm.nome_demanda,
      tipo_demanda: createForm.tipo_demanda,
      numero_processo: createForm.numero_processo,
      tipo_processo: createForm.tipo_processo,
      prazo_entrega: createForm.prazo_entrega,
      responsavel_registro: getCurrentUserName(),
      responsavel_triagem: createForm.responsavel_triagem || null,
      enviar_email_triagem: createForm.enviar_email_triagem || false,
      mensagem_email_triagem: createForm.mensagem_email_triagem || null,
      observacoes: createForm.observacoes || null,
      assunto_id: createForm.assunto_id === 'outro' ? null : createForm.assunto_id,
      assunto_outro: createForm.assunto_id === 'outro' ? createForm.assunto_outro : null,
      // Informações do Paciente
      nome_paciente: createForm.nome_paciente || null,
      cpf_paciente: createForm.cpf_paciente || null,
      data_nascimento_paciente: createForm.data_nascimento_paciente || null,
      sexo_paciente: createForm.sexo_paciente || null,
      outras_informacoes_paciente: createForm.outras_informacoes_paciente || null,
    }
    
    const response = await apiClient.post('/api/v1/juridico/', payload)
    const demandaId = response.data.id
    
    // Fazer upload dos anexos se houver
    if (anexosParaCriacao.value.length > 0) {
      uploadingAnexoCriacao.value = true
      for (const anexo of anexosParaCriacao.value) {
        try {
          const formData = new FormData()
          formData.append('arquivo', anexo.file)
          formData.append('nome', anexo.nome)
          formData.append('etapa', '1')
          formData.append('descricao', 'Anexo da criação')
          
          await apiClient.post(
            `/api/v1/juridico/${demandaId}/anexo/`,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          )
        } catch (error) {
          console.error('Erro ao fazer upload do anexo:', error)
          // Continuar com os próximos anexos mesmo se um falhar
        }
      }
      uploadingAnexoCriacao.value = false
    }
    
    closeCreateModal()
    await loadDemandas()
  } catch (error) {
    console.error('Erro ao criar demanda:', error)
    alert('Erro ao criar demanda. Verifique os dados e tente novamente.')
  } finally {
    isCreating.value = false
  }
}

const handleEditClick = (demanda) => {
  if (!podeEditar.value) {
    showPermissionModal.value = true
    return
  }
  openModal(demanda)
}

const openDetailsModal = async (demanda) => {
  try {
    const response = await apiClient.get(`/api/v1/juridico/${demanda.id}/gerenciar/`)
    const data = response.data
    selectedDemanda.value = {
      ...demanda,
      ...data
    }
  } catch (error) {
    console.error('Erro ao carregar detalhes:', error)
    selectedDemanda.value = demanda
  }
  showDetailsModal.value = true
}

const closeDetailsModal = () => {
  showDetailsModal.value = false
  selectedDemanda.value = null
}

const saveChanges = async () => {
  if (isSaving.value) return
  
  isSaving.value = true
  
  try {
    // Atualizar estados das fases baseado no que está sendo salvo
    let statusFinal = 'Pendente'
    
    switch (currentPhase.value) {
      case 2:
        if (verificarFaseCompleta(2)) {
          fase2Completa.value = true
          statusFinal = 'Aguardando Jurídico'
        } else {
          statusFinal = 'Em Triagem'
        }
        break
      
      case 3:
        if (verificarFaseCompleta(3)) {
          fase3Completa.value = true
          statusFinal = 'Preparação do Ofício'
        } else {
          statusFinal = 'Aguardando Jurídico'
        }
        break
      
      case 4:
        if (verificarFaseCompleta(4)) {
          fase4Completa.value = true
          statusFinal = 'Cumprido'
          isConcluido.value = true
        } else {
          statusFinal = 'Preparação do Ofício'
        }
        break
      
      default:
        statusFinal = modalForm.statusFinal || 'Pendente'
    }
    
    const payload = {
      // Etapa 2
      data_inicio_triagem: modalForm.dataInicioTriagem,
      data_devolucao_triagem: modalForm.dataDevolucaoTriagem,
      responsavel_triagem: modalForm.responsavelTriagem,
      prioridade: modalForm.prioridade,
      analise_triagem: modalForm.analiseTriagem,
      mensagem_email_juridico_etapa2: modalForm.mensagemEmailJuridicoEtapa2,
      enviar_email_juridico_etapa2: modalForm.enviarEmailJuridicoEtapa2,
      destinatarios_email_juridico_etapa2: modalForm.destinatariosEmailJuridicoEtapa2,
      
      // Etapa 3 - Resposta do Jurídico
      data_recebimento_resposta_juridico: modalForm.dataRecebimentoRespostaJuridico,
      resposta_juridico: modalForm.respostaJuridico,
      responsavel_recebimento_juridico: modalForm.responsavelRecebimentoJuridico,
      
      // Etapa 4 - Envio para SMS
      data_preparacao_oficio: modalForm.dataPreparacaoOficio,
      responsavel_oficio: modalForm.responsavelOficio,
      data_envio_judiciario: modalForm.dataEnvioJudiciario,
      responsavel_envio: modalForm.responsavelEnvio,
      metodo_envio: modalForm.metodoEnvio,
      mensagem_email_sms: modalForm.mensagemEmailSms,
      enviar_email_sms: modalForm.enviarEmailSms,
      destinatarios_email_sms: modalForm.destinatariosEmailSms,
      
      status: statusFinal
    }
    
    try {
      const response = await apiClient.put(`/api/v1/juridico/${selectedDemanda.value.id}/gerenciar/`, payload)
      
      // Recarregar dados completos da demanda para atualizar status e flags
      const demandaResponse = await apiClient.get(`/api/v1/juridico/${selectedDemanda.value.id}/gerenciar/`)
      const demandaData = demandaResponse.data
      
      // Atualizar status na lista
      const demandaIndex = demandas.value.findIndex(d => d.id === selectedDemanda.value.id)
      if (demandaIndex !== -1) {
        demandas.value[demandaIndex].status = demandaData.status || statusFinal
      }
      
      // Atualizar selectedDemanda com os dados atualizados
      selectedDemanda.value = {
        ...selectedDemanda.value,
        status: demandaData.status || statusFinal
      }
      
      // Verificar se houve erro de email na resposta
      if (response.data?.email_error || demandaData.email_erro_juridico_etapa2 || demandaData.email_erro_sms) {
        // Armazenar informações para reenvio
        erroEmailFase.value = currentPhase.value
        payloadErroEmail.value = { ...payload }
        
        // Atualizar flags de erro
        await loadDemandaData(selectedDemanda.value.id)
      } else {
        // Limpar flags de erro se não houver mais erro
        erroEmailFase.value = null
        payloadErroEmail.value = null
      }
      
      // Avançar para próxima etapa mesmo com erro de email (a etapa foi salva)
      if (statusFinal === 'Aguardando Jurídico' && currentPhase.value === 2) {
        currentPhase.value = 3
        fase2Completa.value = true
      } else if (statusFinal === 'Preparação do Ofício' && currentPhase.value === 3) {
        currentPhase.value = 4
        fase3Completa.value = true
      } else if (statusFinal === 'Cumprido' && currentPhase.value === 4) {
        // Se concluído, fechar modal
        fase4Completa.value = true
        closeModal()
      }
      
      await loadDemandas()
  } catch (error) {
    console.error('Erro ao salvar:', error)
      
      // Verificar se o erro é relacionado a email
      const errorMessageText = error.response?.data?.detail || error.message || ''
      const isEmailError = errorMessageText.includes('email') || 
                          errorMessageText.includes('Email') || 
                          errorMessageText.includes('525') ||
                          errorMessageText.includes('desativada') ||
                          errorMessageText.includes('Erro ao enviar email') ||
                          error.response?.status === 500
      
      if (isEmailError) {
        // Armazenar informações para reenvio
        erroEmailFase.value = currentPhase.value
        payloadErroEmail.value = { ...payload }
        
        // Mostrar modal de erro de email
        errorMessage.value = 'A demanda foi salva com sucesso, mas houve um erro ao enviar o e-mail. Verifique as configurações de e-mail do sistema.'
        showErrorBanner.value = true
        
        // Ainda assim, fechar o modal e recarregar as demandas
        closeModal()
        await loadDemandas()
      } else {
        alert('Erro ao salvar alterações. Tente novamente.')
      }
    }
  } catch (error) {
    console.error('Erro geral:', error)
    alert('Erro ao salvar alterações. Tente novamente.')
  } finally {
    isSaving.value = false
  }
}

// Função para carregar dados da demanda
const loadDemandaData = async (demandaId) => {
  try {
    const response = await apiClient.get(`/api/v1/juridico/${demandaId}/gerenciar/`)
    const data = response.data
    
    // Atualizar status do selectedDemanda
    if (selectedDemanda.value) {
      selectedDemanda.value.status = data.status
    }
    
    // Atualizar flags de erro
    if (data.email_erro_juridico_etapa2) {
      erroEmailFase.value = 2
    } else if (data.email_erro_sms) {
      erroEmailFase.value = 4
    } else {
      erroEmailFase.value = null
    }
    
    // Atualizar estado das fases baseado nos dados
    if (data.status === 'Cumprido') {
      isConcluido.value = true
      fase2Completa.value = true
      fase3Completa.value = true
      fase4Completa.value = true
    } else if (data.status === 'Preparação do Ofício') {
      fase2Completa.value = true
      fase3Completa.value = true
    } else if (data.status === 'Aguardando Jurídico') {
      fase2Completa.value = true
    }
  } catch (error) {
    console.error('Erro ao carregar dados da demanda:', error)
  }
}

// Função para reenviar email após erro
const reenviarEmail = async (fase) => {
  if (!selectedDemanda.value) {
    return
  }
  
  isReenviandoEmail.value = true
  
  try {
    // Construir payload baseado na fase
    let payload = {}
    
    if (fase === 2) {
      payload = {
        enviar_email_juridico_etapa2: true,
        mensagem_email_juridico_etapa2: modalForm.mensagemEmailJuridicoEtapa2 || '',
        destinatarios_email_juridico_etapa2: modalForm.destinatariosEmailJuridicoEtapa2
      }
    } else if (fase === 4) {
      payload = {
        enviar_email_sms: true,
        mensagem_email_sms: modalForm.mensagemEmailSms || '',
        destinatarios_email_sms: modalForm.destinatariosEmailSms
      }
    }
    
    await apiClient.put(`/api/v1/juridico/${selectedDemanda.value.id}/gerenciar/`, payload)
    
    // Sucesso - mostrar mensagem e recarregar dados
    successMessage.value = 'E-mail reenviado com sucesso!'
    showSuccessBanner.value = true
    setTimeout(() => {
      showSuccessBanner.value = false
    }, 3000)
    
    // Recarregar dados da demanda para atualizar flags
    await loadDemandaData(selectedDemanda.value.id)
    await loadDemandas()
  } catch (error) {
    console.error('Erro ao reenviar email:', error)
    alert('Erro ao reenviar e-mail. Tente novamente.')
  } finally {
    isReenviandoEmail.value = false
  }
}

// Funções de Gráficos e Relatórios
const carregarGraficos = async () => {
  carregandoGraficos.value = true
  try {
    const params = {}
    if (filtrosGrafico.data_inicio) params.data_inicio = filtrosGrafico.data_inicio
    if (filtrosGrafico.data_fim) params.data_fim = filtrosGrafico.data_fim
    if (filtrosGrafico.tipo_processo) params.tipo_processo = filtrosGrafico.tipo_processo
    if (filtrosGrafico.tipo_demanda) params.tipo_demanda = filtrosGrafico.tipo_demanda
    if (filtrosGrafico.status) params.status = filtrosGrafico.status
    if (filtrosGrafico.assunto_id) params.assunto_id = filtrosGrafico.assunto_id
    
    const response = await apiClient.get('/api/v1/juridico/estatisticas/graficos/', { params })
    dadosGraficos.value = response.data
    
    // Aguardar renderização do DOM e desativar loading
    carregandoGraficos.value = false
    await nextTick()
    
    // Pequeno delay para garantir que os canvas estejam totalmente renderizados
    setTimeout(() => {
      criarGraficos()
    }, 200)
  } catch (error) {
    console.error('Erro ao carregar gráficos:', error)
    carregandoGraficos.value = false
  }
}

const criarGraficos = () => {
  const isDarkMode = document.documentElement.classList.contains('dark')
  const textColor = isDarkMode ? '#f3f4f6' : '#1f2937'
  const gridColor = isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'
  
  // Destruir gráficos existentes
  Object.values(chartInstances).forEach(chart => {
    if (chart) chart.destroy()
  })
  
  console.log('Criando gráficos...', {
    chartTipoProcesso: chartTipoProcesso.value,
    chartTipoDemanda: chartTipoDemanda.value,
    chartPrazoEntrega: chartPrazoEntrega.value,
    chartAssunto: chartAssunto.value,
    dadosGraficos: dadosGraficos.value
  })
  
  // Gráfico por Tipo de Processo
  if (chartTipoProcesso.value && dadosGraficos.value.tipo_processo && dadosGraficos.value.tipo_processo.labels && dadosGraficos.value.tipo_processo.labels.length > 0) {
    chartInstances.tipoProcesso = new Chart(chartTipoProcesso.value, {
      type: 'doughnut',
      data: {
        labels: dadosGraficos.value.tipo_processo.labels,
        datasets: [{
          data: dadosGraficos.value.tipo_processo.data,
          backgroundColor: [
            'rgba(59, 130, 246, 0.8)',
            'rgba(34, 197, 94, 0.8)',
            'rgba(249, 115, 22, 0.8)',
            'rgba(168, 85, 247, 0.8)',
            'rgba(236, 72, 153, 0.8)'
          ]
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom',
            labels: { color: textColor }
          }
        }
      }
    })
  }
  
  // Gráfico por Tipo de Demanda
  if (chartTipoDemanda.value && dadosGraficos.value.tipo_demanda && dadosGraficos.value.tipo_demanda.labels && dadosGraficos.value.tipo_demanda.labels.length > 0) {
    chartInstances.tipoDemanda = new Chart(chartTipoDemanda.value, {
      type: 'bar',
      data: {
        labels: dadosGraficos.value.tipo_demanda.labels,
        datasets: [{
          label: 'Demandas',
          data: dadosGraficos.value.tipo_demanda.data,
          backgroundColor: 'rgba(59, 130, 246, 0.8)'
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          title: { display: false }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: { color: textColor, stepSize: 1 },
            grid: { color: gridColor }
          },
          x: {
            ticks: { color: textColor },
            grid: { display: false }
          }
        }
      }
    })
  }
  
  // Gráfico por Prazo de Entrega
  if (chartPrazoEntrega.value && dadosGraficos.value.prazo_entrega && dadosGraficos.value.prazo_entrega.labels && dadosGraficos.value.prazo_entrega.labels.length > 0) {
    chartInstances.prazoEntrega = new Chart(chartPrazoEntrega.value, {
      type: 'pie',
      data: {
        labels: dadosGraficos.value.prazo_entrega.labels,
        datasets: [{
          data: dadosGraficos.value.prazo_entrega.data,
          backgroundColor: [
            'rgba(34, 197, 94, 0.8)',
            'rgba(239, 68, 68, 0.8)'
          ]
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom',
            labels: { color: textColor }
          }
        }
      }
    })
  }
  
  // Gráfico por Assunto
  if (chartAssunto.value && dadosGraficos.value.assunto && dadosGraficos.value.assunto.labels && dadosGraficos.value.assunto.labels.length > 0) {
    chartInstances.assunto = new Chart(chartAssunto.value, {
      type: 'bar',
      data: {
        labels: dadosGraficos.value.assunto.labels,
        datasets: [{
          label: 'Demandas',
          data: dadosGraficos.value.assunto.data,
          backgroundColor: 'rgba(168, 85, 247, 0.8)'
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'y',
        plugins: {
          legend: { display: false },
          title: { display: false }
        },
        scales: {
          x: {
            beginAtZero: true,
            ticks: { color: textColor, stepSize: 1 },
            grid: { color: gridColor }
          },
          y: {
            ticks: { color: textColor },
            grid: { display: false }
          }
        }
      }
    })
  }
}

const carregarRelatorio = async () => {
  carregandoRelatorio.value = true
  try {
    const params = {}
    if (filtrosRelatorio.status) params.status = filtrosRelatorio.status
    if (filtrosRelatorio.data_inicio) params.data_inicio = filtrosRelatorio.data_inicio
    if (filtrosRelatorio.data_fim) params.data_fim = filtrosRelatorio.data_fim
    if (filtrosRelatorio.tipo_processo) params.tipo_processo = filtrosRelatorio.tipo_processo
    if (filtrosRelatorio.tipo_demanda) params.tipo_demanda = filtrosRelatorio.tipo_demanda
    if (filtrosRelatorio.assunto_id) params.assunto_id = filtrosRelatorio.assunto_id
    if (filtrosRelatorio.prazo_vencido !== null) params.prazo_vencido = filtrosRelatorio.prazo_vencido
    
    const response = await apiClient.get('/api/v1/juridico/relatorio/dados/', { params })
    dadosRelatorio.value = response.data
  } catch (error) {
    console.error('Erro ao carregar relatório:', error)
  } finally {
    carregandoRelatorio.value = false
  }
}

const gerarPDF = async () => {
  try {
    const userStore = useUserStore()
    const nomeUsuario = userStore.nome || 'Usuário'
    
    const doc = new jsPDF('landscape', 'mm', 'a4')
    const pageWidth = doc.internal.pageSize.getWidth()
    const pageHeight = doc.internal.pageSize.getHeight()
    const margin = 15
    const tableWidth = pageWidth - (margin * 2)
    
    // Função para adicionar logo no rodapé
    const addFooterLogo = async () => {
      try {
        let logoBase64 = null
        try {
          const logoModule = await import('@/assets/logo_ccdti.png')
          const logoUrl = logoModule.default || logoModule
          const response = await fetch(logoUrl)
          const blob = await response.blob()
          logoBase64 = await new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onloadend = () => resolve(reader.result)
            reader.onerror = reject
            reader.readAsDataURL(blob)
          })
        } catch (logoError) {
          console.log('Não foi possível carregar a logo:', logoError)
        }
        
        const logoHeight = 15
        const logoY = pageHeight - margin - logoHeight
        
        doc.setDrawColor(200, 200, 200)
        doc.setLineWidth(0.5)
        doc.line(margin, logoY - 5, pageWidth - margin, logoY - 5)
        
        if (logoBase64) {
          try {
            const logoWidth = 35
            const logoHeightAdjusted = 10
            const logoX = pageWidth / 2 - logoWidth / 2
            doc.addImage(logoBase64, 'PNG', logoX, logoY, logoWidth, logoHeightAdjusted)
            doc.setFontSize(8)
            doc.setTextColor(100, 100, 100)
            doc.text('Desenvolvido por TI - CCDTI', pageWidth / 2, logoY + logoHeightAdjusted + 5, { align: 'center' })
          } catch (imgError) {
            console.log('Erro ao adicionar imagem:', imgError)
            doc.setFontSize(9)
            doc.setTextColor(100, 100, 100)
            doc.text('Desenvolvido por TI - CCDTI', pageWidth / 2, logoY + 8, { align: 'center' })
          }
        } else {
          doc.setFontSize(9)
          doc.setTextColor(100, 100, 100)
          doc.text('Desenvolvido por TI - CCDTI', pageWidth / 2, logoY + 8, { align: 'center' })
        }
      } catch (error) {
        console.log('Erro ao adicionar rodapé:', error)
      }
    }
    
    const addPageNumber = (pageNum, totalPages) => {
      doc.setFontSize(8)
      doc.setTextColor(150, 150, 150)
      doc.text(`Página ${pageNum} de ${totalPages}`, pageWidth / 2, pageHeight - 5, { align: 'center' })
    }
    
    let currentY = margin + 10
    const headerHeight = 8
    const rowHeight = 7
    const footerSpace = 30
    const availableHeight = pageHeight - currentY - footerSpace - headerHeight
    const rowsPerPage = Math.floor(availableHeight / rowHeight)
    const totalPages = Math.ceil(dadosRelatorio.value.demandas.length / rowsPerPage) || 1
    
    // Título
    doc.setFontSize(22)
    doc.setFont(undefined, 'bold')
    doc.setTextColor(30, 58, 138)
    const titleText = 'Relatório de Demandas Judiciais'
    doc.text(titleText, pageWidth / 2, currentY, { align: 'center' })
    currentY += 10
    
    // Linha decorativa
    doc.setDrawColor(59, 130, 246)
    doc.setLineWidth(1)
    doc.line(pageWidth / 2 - 50, currentY, pageWidth / 2 + 50, currentY)
    currentY += 8
    
    // Informações do relatório
    doc.setFontSize(10)
    doc.setFont(undefined, 'normal')
    doc.setTextColor(0, 0, 0)
    const infoBoxY = currentY
    doc.setFillColor(240, 245, 255)
    doc.roundedRect(margin, infoBoxY, tableWidth, 18, 3, 3, 'F')
    
    doc.setFontSize(9)
    doc.setTextColor(30, 58, 138)
    doc.setFont(undefined, 'bold')
    doc.text('Informações do Relatório', margin + 5, infoBoxY + 6)
    
    doc.setFontSize(8)
    doc.setTextColor(0, 0, 0)
    doc.setFont(undefined, 'normal')
    doc.text(`Data de geração: ${new Date().toLocaleString('pt-BR')}`, margin + 5, infoBoxY + 11)
    doc.text(`Total de demandas: ${dadosRelatorio.value.total}`, pageWidth / 2, infoBoxY + 11)
    doc.text(`Emitido por: ${nomeUsuario}`, margin + 5, infoBoxY + 16)
    
    currentY += 23
    
    // Filtros aplicados
    if (Object.values(dadosRelatorio.value.filtros_aplicados).some(v => v !== null && v !== '')) {
      const filtrosBoxY = currentY
      doc.setFillColor(249, 250, 251)
      doc.roundedRect(margin, filtrosBoxY, tableWidth, 25, 3, 3, 'F')
      
      doc.setFontSize(9)
      doc.setTextColor(30, 58, 138)
      doc.setFont(undefined, 'bold')
      doc.text('Filtros Aplicados', margin + 5, filtrosBoxY + 6)
      
      doc.setFontSize(8)
      doc.setTextColor(0, 0, 0)
      doc.setFont(undefined, 'normal')
      let filtroY = filtrosBoxY + 11
      const filtros = dadosRelatorio.value.filtros_aplicados
      if (filtros.status) doc.text(`Status: ${filtros.status}`, margin + 5, filtroY)
      if (filtros.data_inicio) doc.text(`Data Início: ${filtros.data_inicio}`, margin + 5, filtroY + 5)
      if (filtros.data_fim) doc.text(`Data Fim: ${filtros.data_fim}`, pageWidth / 2, filtroY)
      if (filtros.tipo_processo) doc.text(`Tipo Processo: ${filtros.tipo_processo}`, pageWidth / 2, filtroY + 5)
      if (filtros.tipo_demanda) doc.text(`Tipo Demanda: ${filtros.tipo_demanda}`, margin + 5, filtroY + 10)
      if (filtros.prazo_vencido !== null) doc.text(`Prazo Vencido: ${filtros.prazo_vencido ? 'Sim' : 'Não'}`, pageWidth / 2, filtroY + 10)
      
      currentY += 30
    }
    
    // Cabeçalho da tabela
    doc.setFillColor(59, 130, 246)
    doc.roundedRect(margin, currentY, tableWidth, headerHeight, 2, 2, 'F')
    doc.setTextColor(255, 255, 255)
    doc.setFontSize(9)
    doc.setFont(undefined, 'bold')
    
    const colWidths = [25, 50, 25, 25, 25, 25, 20, 30]
    const headers = ['Protocolo', 'Nome', 'Tipo Proc.', 'Tipo Dem.', 'Prazo', 'Status', 'Vencido', 'Assunto']
    let xPos = margin + 2
    
    headers.forEach((header, index) => {
      doc.text(header, xPos, currentY + 5)
      xPos += colWidths[index]
    })
    
    currentY += headerHeight + 2
    
    // Dados da tabela
    doc.setTextColor(0, 0, 0)
    doc.setFont(undefined, 'normal')
    doc.setFontSize(7)
    
    for (let index = 0; index < dadosRelatorio.value.demandas.length; index++) {
      const demanda = dadosRelatorio.value.demandas[index]
      
      if (currentY + rowHeight > pageHeight - footerSpace) {
        await addFooterLogo()
        addPageNumber(Math.floor(index / rowsPerPage) + 1, totalPages)
        doc.addPage()
        currentY = margin + 10
      }
      
      xPos = margin + 2
      const values = [
        demanda.protocolo || '',
        (demanda.nome_demanda || '').substring(0, 20),
        (demanda.tipo_processo || '').substring(0, 8),
        (demanda.tipo_demanda || '').substring(0, 8),
        formatDate(demanda.prazo_entrega) || '',
        (demanda.status || '').substring(0, 8),
        demanda.prazo_vencido ? 'Sim' : 'Não',
        (demanda.assunto || '').substring(0, 15)
      ]
      
      values.forEach((value, colIndex) => {
        doc.text(value, xPos, currentY + 4)
        xPos += colWidths[colIndex]
      })
      
      currentY += rowHeight
    }
    
    await addFooterLogo()
    addPageNumber(totalPages, totalPages)
    
    doc.save(`Relatorio_Demandas_Judiciais_${new Date().toISOString().split('T')[0]}.pdf`)
  } catch (error) {
    console.error('Erro ao gerar PDF:', error)
    alert('Erro ao gerar PDF. Tente novamente.')
  }
}

// Watcher para carregar gráficos quando a aba for aberta
watch([showGraficosRelatorios, graficosRelatoriosTab], async ([show, tab]) => {
  if (show && tab === 'graficos') {
    if (Object.keys(dadosGraficos.value).length === 0) {
      await carregarGraficos()
    } else {
      await nextTick()
      setTimeout(() => {
        criarGraficos()
      }, 100)
    }
  }
})

// Observer do tema (controlado pelo BaseTemplate) para gráficos
let themeObserver = null

// Inicialização
onMounted(async () => {
        // Tema é controlado pelo BaseTemplate; sincronizamos isDark para os gráficos
        isDark.value = document.documentElement.classList.contains('dark')
        themeObserver = new MutationObserver(() => {
          isDark.value = document.documentElement.classList.contains('dark')
        })
        themeObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] })

        // Carregar perfil do usuário para obter nome completo
        if (!perfilStore.carregado) {
          await perfilStore.carregarPerfil()
        }
        
        await loadDemandas()
        await loadJuridicoUsers()
        await loadEmailsCustomizados()
        await loadAssuntos()
        
        // Verificar se há parâmetro de demanda na URL para abrir modal automaticamente
        const urlParams = new URLSearchParams(window.location.search)
        const demandaId = urlParams.get('demanda')
        if (demandaId) {
          // Aguardar carregamento das demandas antes de abrir o modal
          const demandaIdInt = parseInt(demandaId)
          
          // Tentar encontrar a demanda na lista carregada
          let demanda = demandas.value.find(d => d.id === demandaIdInt)
          
          if (demanda) {
            // Se encontrou, abrir modal imediatamente
            // Se o usuário não tem permissão para editar, abrir modal de detalhes
            if (!podeEditar.value) {
              openDetailsModal(demanda)
            } else {
              openModal(demanda)
            }
          } else {
            // Se não encontrou, tentar carregar diretamente da API
            try {
              const response = await apiClient.get(`/api/v1/juridico/${demandaIdInt}/gerenciar/`)
              const data = response.data
              // Criar objeto demanda mínimo para abrir o modal
              demanda = {
                id: demandaIdInt,
                protocolo: data.protocolo,
                nome_demanda: data.nome_demanda,
                status: data.status
              }
              // Se o usuário não tem permissão para editar, abrir modal de detalhes
              if (!podeEditar.value) {
                openDetailsModal(demanda)
              } else {
                openModal(demanda)
              }
            } catch (error) {
              console.error('Erro ao carregar demanda da URL:', error)
            }
          }
        }
      })

onUnmounted(() => {
  if (themeObserver) {
    themeObserver.disconnect()
  }
})

      // Watchers para atualização automática
      watch([searchTerm, selectedStatus, itemsPerPage], () => {
        currentPage.value = 1 // Resetar para primeira página ao filtrar
        loadDemandas()
      })
</script>
